import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { handleAllError, handleErrorToast, handleCustomErrorToast } from "../CustomFunctions";
import { BASE_URL } from "../../config/axios";
import { AddwithWhiteCircle, Attachment, DeleteDustbin, UpdatePencil } from "../AllSvg";
import Select from "react-select";
import { CSSForSelect } from "../CustomUtilities";
import * as XLSX from "xlsx";



// const ProjectAdd = ({ getProjects, SUB_COMPANIES }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [clientList, setClientList] = useState([]);
//     const [typeList, setTypeList] = useState([]);
//     const [clientLoading, setClientLoading] = useState(false);
//     const [departmentLists, setDepartmentLists] = useState([]);
//     const [buffer1, setBuffering1] = useState(true);
//     const [ProjectTypeLoading, setProjectTypeLoading] = useState(false);

//     const initialForm = {
//         project_code: "",
//         project_short_name: "",
//         project_full_name: "",
//         project_description: "",
//         project_status: "",
//         project_start_date: null,
//         project_end_date: null,
//         project_type: "",
//         project_client: "",
//         department: "",
//         sub_company: sessionStorage.getItem("company_id"),
//         created_by: sessionStorage.getItem("emp_code"),
//         updated_by: sessionStorage.getItem('emp_code'),
//     };

//     const [formData, setFormData] = useState(initialForm);
//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);

//     const handleClose = () => {
//         setFormData(initialForm);
//         setErrors({});
//         setInputState({});
//         setShow(false);
//     };

//     const handleShow = async () => {
//         setShow(true);
//         setErrors({});
//         await fetchClients();
//         await fetchProjectType();
//         await fetchDepartments();
//     };

//     //  Fetch client list from API
//     const fetchClients = async () => {
//         setClientLoading(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
//             // Adjust the response key based on your actual API response shape
//             const data = Array.isArray(res.data) ? res.data : res.data.results || [];
//             setClientList(data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setClientLoading(false);
//         }
//     };

//     //  Fetch client list from API
//     const fetchProjectType = async () => {
//         setProjectTypeLoading(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
//             // Adjust the response key based on your actual API response shape
//             const data = Array.isArray(res.data) ? res.data : res.data.results || [];
//             setTypeList(data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setProjectTypeLoading(false);
//         }
//     };

//     const fetchDepartments = async () => {
//         try {
//             setBuffering1(true)
//             const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${formData.sub_company || 'null'}/active/`);
//             setDepartmentLists(dep.data)
//         } catch (err) {
//         } finally {
//             setBuffering1(false)
//         }
//     };

//     // ----------------------------------------------------------------
//     // Validation
//     // ----------------------------------------------------------------
//     const fieldLabels = {
//         project_code: "Project Code",
//         project_short_name: "Project Short Name",
//         project_full_name: "Project Full Name",
//         project_type: "Project Type",
//         project_client: "Client Name",
//         department: "Department",
//         project_description: "Project Description",
//         project_status: "Project Status",
//         project_start_date: "Start Date",
//         project_end_date: "End Date",
//         sub_company: "Subcompany",
//     };

//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "project_code",
//             "project_short_name",
//             "project_full_name",
//             "project_type",
//             "project_client",
//             "department",
//             "sub_company",
//         ];

//         requiredFields.forEach((field) => {
//             if (!formData[field] || String(formData[field]).trim() === "") {
//                 newErrors[field] = `${fieldLabels[field]} is required!`;
//             }
//         });

//         //  Project code format validation: alphanumeric + hyphens only
//         if (formData.project_code && !/^[A-Za-z0-9\-_/]+$/.test(formData.project_code)) {
//             newErrors.project_code = "Project Code can only contain letters, numbers, hyphens, underscores, or slashes.";
//         }

//         //  Short name length
//         if (formData.project_short_name && formData.project_short_name.length > 100) {
//             newErrors.project_short_name = "Short Name must be under 100 characters.";
//         }

//         //  Full name length
//         if (formData.project_full_name && formData.project_full_name.length > 500) {
//             newErrors.project_full_name = "Full Name must be under 500 characters.";
//         }

//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };


//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
//         setFormData((prev) => ({ ...prev, [name]: value }));
//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };



//     const handleSelectChange = (name, selectedOption) => {
//         const value =
//             selectedOption && typeof selectedOption === "object"
//                 ? selectedOption.value
//                 : selectedOption || "";

//         setInputState({ ...inputState, [name]: value ? "green" : "" });
//         setFormData({ ...formData, [name]: value });

//         if ((value || "").trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;

//         setLoading(true);
//         const loadingToastId = toast.loading("Creating project, please wait...");
//         try {
//             const payload = {
//                 ...formData,
//                 created_at: new Date().toISOString(),
//             };
//             const res = await axios.post(`${BASE_URL}/mantra_projects/projects/`, payload);
//             if (res.status === 200 || res.status === 201) {
//                 toast.dismiss(loadingToastId);
//                 toast.success("Project created successfully!");
//                 if (getProjects) await getProjects();
//                 handleClose();
//             } else {
//                 alert(res);
//             }
//         } catch (err) {
//             handleAllError(err, loadingToastId);
//         } finally {
//             setLoading(false);
//             toast.dismiss(loadingToastId);
//         }
//     };

//     // ----------------------------------------------------------------
//     // Dropdown option arrays
//     // ----------------------------------------------------------------
//     const projectTypeOptions = typeList.map((type) => ({
//         value: type.id,
//         label: type.type_name,
//     }));

//     // const clientOptions = clientList.map((client) => ({
//     //     //  Adjust 'client.id' and 'client.name' to your actual API field names
//     //     value: client.id || client.project_client || client.name,
//     //     label: client.project_client || client.name,
//     // }));
//     const clientOptions = clientList.map(client => ({
//         value: client.id,
//         label: client.client_name
//     }));


//     return (
//         <>
//             {/*  Super Admin trigger button — style matches your existing pattern */}
//             <button title="Add Project" className="upload-svg" onClick={handleShow}>
//                 <AddwithWhiteCircle /> Add Project
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add New Project</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             <div className="form-flex-wrap" style={{ gap: '0px' }}>

//                                 {/* Subcompany  */}
//                                 <div className="flex-column">
//                                     <label className="form-labels font-weight500 font-size-subheading">
//                                         Sub Company<span className="required">*</span>
//                                     </label>
//                                     <select
//                                         name="sub_company"
//                                         value={formData.sub_company}
//                                         onChange={handleInputChange}
//                                         className="form-input"
//                                     >
//                                         <option value="">Select a Company</option>
//                                         {SUB_COMPANIES.map((i, index) => (
//                                             <option key={index} value={i.id}>
//                                                 {i.title}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {errors.sub_company && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.sub_company}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/*  Department */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="department"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Department<span className="required">*</span>
//                                     </label>
//                                     {buffer1 ?
//                                         <div className="form-loader">
//                                             <div className="bar-loader"></div>
//                                         </div>
//                                         :
//                                         <>
//                                             <select
//                                                 name="department"
//                                                 onChange={(e) => handleSelectChange("department", { value: e.target.value, label: e.target.options[e.target.selectedIndex].text })}
//                                                 value={formData.department}
//                                                 className={`form-input  form-input-background`}
//                                             >
//                                                 <option value="">Select Department for Projects</option>
//                                                 {sessionStorage.getItem('company_id') === '025d0b52-e892-4868-a3bb-6b70dcdffb4d' ?
//                                                     <option value="Prebid">Prebid</option>
//                                                     : null}
//                                                 {departmentLists
//                                                     .sort((a, b) => a.title - b.title)
//                                                     .map((i, index) => (
//                                                         <option value={i.id}>{i.title}</option>
//                                                     ))};
//                                             </select>
//                                         </>}
//                                     {errors.department && (
//                                         <span className="error-message font-size-text">{errors.department}</span>
//                                     )}
//                                 </div>


//                                 {/*  Project Code */}
//                                 <div className="flex-column">
//                                     <label htmlFor="project_code" className="form-labels font-weight500 announce-date">
//                                         Project Code<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_code"
//                                         type="text"
//                                         name="project_code"
//                                         placeholder="e.g. CSMS-001"
//                                         onChange={handleInputChange}
//                                         value={formData.project_code}
//                                         className={`form-input ${errors.project_code ? "error" : inputState.project_code ? "success" : ""}`}
//                                     />
//                                     {errors.project_code && (
//                                         <span className="error-message font-size-text">{errors.project_code}</span>
//                                     )}
//                                 </div>

//                                 {/*  Project Short Name */}
//                                 <div className="flex-column">
//                                     <label htmlFor="project_short_name" className="form-labels font-weight500 announce-date">
//                                         Project Short Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_short_name"
//                                         type="text"
//                                         name="project_short_name"
//                                         placeholder="e.g. CSMS Phase 1"
//                                         onChange={handleInputChange}
//                                         value={formData.project_short_name}
//                                         className={`form-input ${errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""}`}
//                                     />
//                                     {errors.project_short_name && (
//                                         <span className="error-message font-size-text">{errors.project_short_name}</span>
//                                     )}
//                                 </div>

//                                 {/*  Project Full Name */}
//                                 <div className="flex-column">
//                                     <label htmlFor="project_full_name" className="form-labels font-weight500 announce-date">
//                                         Project Full Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_full_name"
//                                         type="text"
//                                         name="project_full_name"
//                                         placeholder="e.g. Centralized Monitoring System Phase 1 - Delhi"
//                                         onChange={handleInputChange}
//                                         value={formData.project_full_name}
//                                         className={`form-input ${errors.project_full_name ? "error" : inputState.project_full_name ? "success" : ""}`}
//                                     />
//                                     {errors.project_full_name && (
//                                         <span className="error-message font-size-text">{errors.project_full_name}</span>
//                                     )}
//                                 </div>

//                                 {/*  Project Type — dropdown */}
//                                 <div className="flex-column">
//                                     <label htmlFor="project_type" className="form-labels font-weight500 announce-date">
//                                         Project Type<span className="required">*</span>
//                                     </label>
//                                     {ProjectTypeLoading ? (
//                                         <div className="form-loader"><div className="bar-loader"></div></div>
//                                     ) : (
//                                         <Select
//                                             id="project_type"
//                                             name="project_type"
//                                             options={projectTypeOptions}
//                                             onChange={(selected) =>
//                                                 handleSelectChange("project_type", selected)
//                                             }
//                                             value={
//                                                 projectTypeOptions.find(
//                                                     (option) => option.value === formData.project_type
//                                                 ) || null
//                                             }
//                                             placeholder="Select Project Type"
//                                             isClearable
//                                             styles={CSSForSelect}
//                                         />
//                                     )}
//                                     {errors.project_type && (
//                                         <span className="error-message font-size-text">{errors.project_type}</span>
//                                     )}
//                                 </div>

//                                 {/*  Client Name */}
//                                 <div className="flex-column">
//                                     <label htmlFor="project_client" className="form-labels font-weight500 announce-date">
//                                         Client Name<span className="required">*</span>
//                                     </label>
//                                     {clientLoading ? (
//                                         <div className="form-loader"><div className="bar-loader"></div></div>
//                                     ) : (
//                                         <Select
//                                             id="project_client"
//                                             name="project_client"
//                                             options={clientOptions}
//                                             onChange={(selected) =>
//                                                 handleSelectChange("project_client", selected)
//                                             }
//                                             value={
//                                                 clientOptions.find(
//                                                     (o) => o.value === formData.project_client
//                                                 ) || null
//                                             }
//                                             placeholder="Search & Select client..."
//                                             isClearable
//                                             noOptionsMessage={() => "No clients found"}
//                                             styles={CSSForSelect}
//                                         />
//                                     )}
//                                     {errors.project_client && (
//                                         <span className="error-message font-size-text">{errors.project_client}</span>
//                                     )}
//                                 </div>

//                             </div>

//                             {/* Footer */}
//                             <div className="button-models">
//                                 <button
//                                     className="model-button model-button-cancel font-weight500"
//                                     onClick={handleClose}
//                                     disabled={loading}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-leave font-size-heading"
//                                     onClick={handleFormSubmit}
//                                     disabled={loading}
//                                 >
//                                     {loading ? "Adding..." : "Add Project"}
//                                 </button>
//                             </div>
//                             <p className="error-message font-size-text">
//                                 {isSubmitted && Object.keys(errors).length > 0 && (
//                                     Object.keys(errors).length > 5 ? (
//                                         <h5 className="text-center">Please fill all mandatory fields!</h5>
//                                     ) : (
//                                         <h6 className="text-center">
//                                             {Object.keys(errors).map((field) =>
//                                                 field.charAt(0).toUpperCase() + field.slice(1)
//                                             ).join(', ') + ' are required!'}
//                                         </h6>
//                                     )
//                                 )}
//                             </p>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const ProjectAdd = ({ getProjects, SUB_COMPANIES }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [clientLoading, setClientLoading] = useState(false);
    const [departmentLists, setDepartmentLists] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [ProjectTypeLoading, setProjectTypeLoading] = useState(false);

    const subCompanyId = sessionStorage.getItem("company_id");

    const initialForm = {
        project_code: "",
        project_short_name: "",
        project_full_name: "",
        project_description: "",
        project_status: "",
        project_start_date: null,
        project_end_date: null,
        project_type: "",
        project_client: "",
        department: "",
        sub_company: subCompanyId,
        created_by: sessionStorage.getItem("emp_code"),
        updated_by: sessionStorage.getItem("emp_code"),
    };

    const [formData, setFormData] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleClose = () => {
        setFormData(initialForm);
        setErrors({});
        setInputState({});
        setShow(false);
    };

    const handleShow = async () => {
        setShow(true);
        setErrors({});
        await fetchClients();
        await fetchProjectType();
        await fetchDepartments();
    };

    const fetchClients = async () => {
        setClientLoading(true);
        try {

            // const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
            const res = await axios.get(`${BASE_URL}/mantra_projects/clientsearch/`);
            const data = Array.isArray(res.data) ? res.data : res.data.results || [];
            setClientList(data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setClientLoading(false);
        }
    };

    const fetchProjectType = async () => {
        setProjectTypeLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
            const data = Array.isArray(res.data) ? res.data : res.data.results || [];
            setTypeList(data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setProjectTypeLoading(false);
        }
    };

    const fetchDepartments = async () => {
        try {
            setBuffering1(true);
            const dep = await axios.get(
                `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompanyId || "null"}/active/`
            );
            setDepartmentLists(dep.data);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const fieldLabels = {
        project_code: "Project Code",
        project_short_name: "Project Short Name",
        project_full_name: "Project Full Name",
        project_type: "Project Type",
        project_client: "Client Name",
        department: "Department",
        project_description: "Project Description",
        project_status: "Project Status",
        project_start_date: "Start Date",
        project_end_date: "End Date",
        sub_company: "Subcompany",
    };

    const validateForm = () => {
        const newErrors = {};
        // department and project_full_name are NOT mandatory
        const requiredFields = [
            "project_code",
            "project_short_name",
            "project_type",
            "project_client",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || String(formData[field]).trim() === "") {
                newErrors[field] = `${fieldLabels[field]} is required!`;
            }
        });

        if (formData.project_code && !/^[A-Za-z0-9\-_/]+$/.test(formData.project_code)) {
            newErrors.project_code =
                "Project Code can only contain letters, numbers, hyphens, underscores, or slashes.";
        }

        // if (formData.project_short_name && formData.project_short_name.length > 100) {
        //     newErrors.project_short_name = "Short Name must be under 100 characters.";
        // }

        // if (formData.project_full_name && formData.project_full_name.length > 500) {
        //     newErrors.project_full_name = "Full Name must be under 500 characters.";
        // }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState((prev) => ({ ...prev, [name]: value.trim() ? "green" : "" }));
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSelectChange = (name, selectedOption) => {
        const value =
            selectedOption && typeof selectedOption === "object"
                ? selectedOption.value
                : selectedOption || "";
        setInputState({ ...inputState, [name]: value ? "green" : "" });
        setFormData({ ...formData, [name]: value });
        if ((value || "").trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Creating project, please wait...");
        try {
            const payload = {
                ...formData,
                sub_company: subCompanyId,
                created_at: new Date().toISOString(),
            };
            const res = await axios.post(`${BASE_URL}/mantra_projects/projects/`, payload);
            if (res.status === 200 || res.status === 201) {
                toast.dismiss(loadingToastId);
                toast.success("Project created successfully!");
                if (getProjects) await getProjects();
                handleClose();
            } else {
                alert(res);
            }
        } catch (err) {
            handleAllError(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const projectTypeOptions = typeList.map((type) => ({
        value: type.id,
        label: type.type_name,
    }));

    const clientOptions = clientList.map((client) => ({
        value: client.id,
        label: client.client_name,
    }));

    return (
        <>
            <button title="Add Project" className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Add Project
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Add New Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap" style={{ gap: "0px" }}>

                                {/* Department */}
                                <div className="flex-column">
                                    <label htmlFor="department" className="form-labels font-weight500 announce-date">
                                        Department
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <select
                                            name="department"
                                            onChange={(e) =>
                                                handleSelectChange("department", {
                                                    value: e.target.value,
                                                    label: e.target.options[e.target.selectedIndex].text,
                                                })
                                            }
                                            value={formData.department}
                                            className="form-input form-input-background"
                                        >
                                            <option value="">Select Department for Projects</option>
                                            {sessionStorage.getItem("company_id") === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" && (
                                                <option value="Prebid">Prebid</option>
                                            )}
                                            {departmentLists
                                                .sort((a, b) => a.title - b.title)
                                                .map((i, index) => (
                                                    <option key={index} value={i.id}>{i.title}</option>
                                                ))}
                                        </select>
                                    )}
                                    {errors.department && (
                                        <span className="error-message font-size-text">{errors.department}</span>
                                    )}
                                </div>

                                {/* Project Code */}
                                <div className="flex-column">
                                    <label htmlFor="project_code" className="form-labels font-weight500 announce-date">
                                        Project Code<span className="required">*</span>
                                    </label>
                                    <input
                                        id="project_code"
                                        type="text"
                                        name="project_code"
                                        placeholder="e.g. CSMS-001"
                                        onChange={handleInputChange}
                                        value={formData.project_code}
                                        className={`form-input ${errors.project_code ? "error" : inputState.project_code ? "success" : ""}`}
                                    />
                                    {errors.project_code && (
                                        <span className="error-message font-size-text">{errors.project_code}</span>
                                    )}
                                </div>

                                {/* Project Short Name */}
                                <div className="flex-column">
                                    <label htmlFor="project_short_name" className="form-labels font-weight500 announce-date">
                                        Project Short Name<span className="required">*</span>
                                    </label>
                                    <input
                                        id="project_short_name"
                                        type="text"
                                        name="project_short_name"
                                        placeholder="e.g. CSMS Phase 1"
                                        onChange={handleInputChange}
                                        value={formData.project_short_name}
                                        className={`form-input ${errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""}`}
                                    />
                                    {errors.project_short_name && (
                                        <span className="error-message font-size-text">{errors.project_short_name}</span>
                                    )}
                                </div>

                                {/* Project Full Name — optional */}
                                <div className="flex-column">
                                    <label htmlFor="project_full_name" className="form-labels font-weight500 announce-date">
                                        Project Full Name
                                    </label>
                                    <input
                                        id="project_full_name"
                                        type="text"
                                        name="project_full_name"
                                        placeholder="e.g. Centralized Monitoring System Phase 1 - Delhi"
                                        onChange={handleInputChange}
                                        value={formData.project_full_name}
                                        className={`form-input ${errors.project_full_name ? "error" : inputState.project_full_name ? "success" : ""}`}
                                    />
                                    {errors.project_full_name && (
                                        <span className="error-message font-size-text">{errors.project_full_name}</span>
                                    )}
                                </div>

                                {/* Project Type */}
                                <div className="flex-column">
                                    <label htmlFor="project_type" className="form-labels font-weight500 announce-date">
                                        Project Type<span className="required">*</span>
                                    </label>
                                    {ProjectTypeLoading ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <Select
                                            id="project_type"
                                            name="project_type"
                                            options={projectTypeOptions}
                                            onChange={(selected) => handleSelectChange("project_type", selected)}
                                            value={projectTypeOptions.find((o) => o.value === formData.project_type) || null}
                                            placeholder="Select Project Type"
                                            isClearable
                                            styles={CSSForSelect}
                                        />
                                    )}
                                    {errors.project_type && (
                                        <span className="error-message font-size-text">{errors.project_type}</span>
                                    )}
                                </div>

                                {/* Client Name */}
                                <div className="flex-column">
                                    <label htmlFor="project_client" className="form-labels font-weight500 announce-date">
                                        Client Name<span className="required">*</span>
                                    </label>
                                    {clientLoading ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <Select
                                            id="project_client"
                                            name="project_client"
                                            options={clientOptions}
                                            onChange={(selected) => handleSelectChange("project_client", selected)}
                                            value={clientOptions.find((o) => o.value === formData.project_client) || null}
                                            placeholder="Search & Select client..."
                                            isClearable
                                            noOptionsMessage={() => "No clients found"}
                                            styles={CSSForSelect}
                                        />
                                    )}
                                    {errors.project_client && (
                                        <span className="error-message font-size-text">{errors.project_client}</span>
                                    )}
                                </div>

                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Adding..." : "Add Project"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(", ") + " are required!"}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

// const ProjectUpdate = ({ i, getProjects, SUB_COMPANIES }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [clientList, setClientList] = useState([]);
//     const [clientLoading, setClientLoading] = useState(false);
//     const [departmentLists, setDepartmentLists] = useState([]);
//     const [buffer1, setBuffering1] = useState(true);
//     const [ProjectTypeLoading, setProjectTypeLoading] = useState(false);
//     const [typeList, setTypeList] = useState([]);

//     const [formData, setFormData] = useState({
//         project_code: "",
//         project_short_name: "",
//         project_full_name: "",
//         project_description: "",
//         project_status: "",
//         project_start_date: null,
//         project_end_date: null,
//         project_type: "",
//         project_client: "",
//         department: "",
//         sub_company: sessionStorage.getItem("company_id"),
//         created_by: sessionStorage.getItem("emp_code"),
//         updated_by: sessionStorage.getItem('emp_code'),
//     });

//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     // ----------------------------------------------------------------
//     // On modal open — pre-fill existing project data + fetch clients
//     // ----------------------------------------------------------------
//     const handleShow = async () => {
//         setFormData({
//             project_code: i.project_code || "",
//             project_short_name: i.project_short_name || "",
//             project_full_name: i.project_full_name || "",
//             project_type: i.project_type || "",
//             project_client: i.project_client || "",
//             department: i.department || "",
//             sub_company: i.sub_company || "",
//         });
//         setErrors({});
//         setInputState({
//             project_code: i.project_code ? "green" : "",
//             project_short_name: i.project_short_name ? "green" : "",
//             project_full_name: i.project_full_name ? "green" : "",
//             project_type: i.project_type ? "green" : "",
//             project_client: i.project_client ? "green" : "",
//             department: i.department ? "green" : "",
//             sub_company: i.sub_company ? "green" : "",
//         });
//         await fetchClients();
//         await fetchProjectType();
//         await fetchDepartments();
//         setShow(true);
//     };

//     const handleClose = () => {
//         setErrors({});
//         setFormData(formData);
//         setShow(false);
//     };

//     // ----------------------------------------------------------------
//     // Fetch client list from API
//     // ----------------------------------------------------------------
//     const fetchClients = async () => {
//         setClientLoading(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
//             const data = Array.isArray(res.data) ? res.data : res.data.results || [];
//             setClientList(data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setClientLoading(false);
//         }
//     };

//     //  Fetch client list from API
//     const fetchProjectType = async () => {
//         setProjectTypeLoading(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
//             // Adjust the response key based on your actual API response shape
//             const data = Array.isArray(res.data) ? res.data : res.data.results || [];
//             setTypeList(data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setProjectTypeLoading(false);
//         }
//     };

//     const fetchDepartments = async () => {
//         try {
//             setBuffering1(true)
//             const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${formData.sub_company || 'null'}/active/`);
//             setDepartmentLists(dep.data)
//         } catch (err) {
//         } finally {
//             setBuffering1(false)
//         }
//     };

//     // ----------------------------------------------------------------
//     // Validation — same rules as ProjectAdd
//     // ----------------------------------------------------------------
//     const fieldLabels = {
//         project_code: "Project Code",
//         project_short_name: "Project Short Name",
//         project_full_name: "Project Full Name",
//         project_type: "Project Type",
//         project_client: "Client Name",
//         department: "Department",
//         project_description: "Project Description",
//         project_status: "Project Status",
//         project_start_date: "Start Date",
//         project_end_date: "End Date",
//         sub_company: "Subcompany",
//     };

//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "project_code",
//             "project_short_name",
//             "project_full_name",
//             "project_type",
//             "project_client",
//             "department",
//             "sub_company",
//         ];

//         requiredFields.forEach((field) => {
//             if (!formData[field] || String(formData[field]).trim() === "") {
//                 newErrors[field] = `${fieldLabels[field]} is required!`;
//             }
//         });

//         if (
//             formData.project_code &&
//             !/^[A-Za-z0-9\-_/]+$/.test(formData.project_code)
//         ) {
//             newErrors.project_code =
//                 "Project Code can only contain letters, numbers, hyphens, underscores, or slashes.";
//         }

//         if (formData.project_short_name && formData.project_short_name.length > 100) {
//             newErrors.project_short_name = "Short Name must be under 100 characters.";
//         }

//         if (formData.project_full_name && formData.project_full_name.length > 500) {
//             newErrors.project_full_name = "Full Name must be under 500 characters.";
//         }

//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };

//     // ----------------------------------------------------------------
//     // Handlers
//     // ----------------------------------------------------------------
//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
//         setFormData({ ...formData, [name]: value });
//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };



//     const handleSelectChange = (name, selectedOption) => {
//         const value =
//             selectedOption && typeof selectedOption === "object"
//                 ? selectedOption.value
//                 : selectedOption || "";

//         setInputState({ ...inputState, [name]: value ? "green" : "" });
//         setFormData({ ...formData, [name]: value });

//         if ((value || "").trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };




//     const handleFormSubmit = async (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;

//         setLoading(true);
//         const loadingToastId = toast.loading("Updating project, please wait...");
//         try {
//             const payload = {
//                 ...formData,
//                 updated_by: sessionStorage.getItem('emp_code'),
//             };
//             const res = await axios.put(
//                 `${BASE_URL}/mantra_projects/projects/${i.id}/`,
//                 payload
//             );
//             if (res.status === 200 || res.status === 201) {
//                 toast.dismiss(loadingToastId);
//                 toast.success("Project updated successfully!");
//                 if (getProjects) await getProjects();
//                 handleClose();
//             } else {
//                 alert(res);
//             }
//         } catch (err) {
//             handleAllError(err, loadingToastId);
//         } finally {
//             setLoading(false);
//             toast.dismiss(loadingToastId);
//         }
//     };

//     // ----------------------------------------------------------------
//     // Dropdown options
//     // ----------------------------------------------------------------
//     // const projectTypeOptions = PROJECT_TYPE_OPTIONS.map((type) => ({
//     //     value: type,
//     //     label: type,
//     // }));

//     const clientOptions = clientList.map(client => ({
//         value: client.id,
//         label: client.client_name
//     }));

//     const projectTypeOptions = typeList.map((type) => ({
//         value: type.id,
//         label: type.type_name,
//     }));


//     // ----------------------------------------------------------------
//     // Render
//     // ----------------------------------------------------------------
//     return (
//         <>
//             <button title="Update Project" className="model-edit-button" onClick={handleShow}>
//                 <UpdatePencil />
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Update Project</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             <div className="form-flex-wrap">

//                                 {/* Subcompany  */}
//                                 <div className="flex-column">
//                                     <label className="form-labels font-weight500 font-size-subheading">
//                                         Sub Company<span className="required">*</span>
//                                     </label>
//                                     <select
//                                         name="sub_company"
//                                         value={formData.sub_company}
//                                         onChange={handleInputChange}
//                                         className="form-input"
//                                     >
//                                         <option value="">Select a Company</option>
//                                         {SUB_COMPANIES.map((i, index) => (
//                                             <option key={index} value={i.id}>
//                                                 {i.title}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {errors.sub_company && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.sub_company}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/*  Department */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="department"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Department<span className="required">*</span>
//                                     </label>
//                                     {buffer1 ?
//                                         <div className="form-loader">
//                                             <div className="bar-loader"></div>
//                                         </div>
//                                         :
//                                         <>
//                                             <select
//                                                 name="department"
//                                                 onChange={(e) => handleSelectChange("department", { value: e.target.value, label: e.target.options[e.target.selectedIndex].text })}
//                                                 value={formData.department}
//                                                 className={`form-input  form-input-background`}
//                                             >
//                                                 <option value="">Select Department for Projects</option>
//                                                 {sessionStorage.getItem('company_id') === '025d0b52-e892-4868-a3bb-6b70dcdffb4d' ?
//                                                     <option value="Prebid">Prebid</option>
//                                                     : null}
//                                                 {departmentLists
//                                                     .sort((a, b) => a.title - b.title)
//                                                     .map((i, index) => (
//                                                         <option value={i.id}>{i.title}</option>
//                                                     ))};
//                                             </select>
//                                         </>}
//                                     {errors.department && (
//                                         <span className="error-message font-size-text">{errors.department}</span>
//                                     )}
//                                 </div>

//                                 {/* Project Code */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="project_code"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Project Code<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_code"
//                                         type="text"
//                                         name="project_code"
//                                         placeholder="e.g. CSMS-001"
//                                         onChange={handleInputChange}
//                                         value={formData.project_code}
//                                         className={`form-input ${errors.project_code
//                                             ? "error"
//                                             : inputState.project_code
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.project_code && (
//                                         <span className="error-message font-size-text">
//                                             {errors.project_code}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/* Project Short Name */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="project_short_name"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Project Short Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_short_name"
//                                         type="text"
//                                         name="project_short_name"
//                                         placeholder="e.g. CSMS Phase 1"
//                                         onChange={handleInputChange}
//                                         value={formData.project_short_name}
//                                         className={`form-input ${errors.project_short_name
//                                             ? "error"
//                                             : inputState.project_short_name
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.project_short_name && (
//                                         <span className="error-message font-size-text">
//                                             {errors.project_short_name}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/* Project Full Name */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="project_full_name"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Project Full Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="project_full_name"
//                                         type="text"
//                                         name="project_full_name"
//                                         placeholder="e.g. Centralized Monitoring System Phase 1 - Delhi"
//                                         onChange={handleInputChange}
//                                         value={formData.project_full_name}
//                                         className={`form-input ${errors.project_full_name
//                                             ? "error"
//                                             : inputState.project_full_name
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                     />
//                                     {errors.project_full_name && (
//                                         <span className="error-message font-size-text">
//                                             {errors.project_full_name}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/* Project Type */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="project_type"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Project Type<span className="required">*</span>
//                                     </label>
//                                     {ProjectTypeLoading ? (
//                                         <div className="form-loader"><div className="bar-loader"></div></div>
//                                     ) : (
//                                         <Select
//                                             id="project_type"
//                                             name="project_type"
//                                             options={projectTypeOptions}
//                                             onChange={(selected) =>
//                                                 handleSelectChange("project_type", selected)
//                                             }
//                                             value={
//                                                 projectTypeOptions.find(
//                                                     (option) => option.value === formData.project_type
//                                                 ) || null
//                                             }
//                                             placeholder="Select Project Type"
//                                             isClearable
//                                             styles={CSSForSelect}
//                                         />
//                                     )}
//                                     {errors.project_type && (
//                                         <span className="error-message font-size-text">
//                                             {errors.project_type}
//                                         </span>
//                                     )}
//                                 </div>

//                                 {/* Client Name */}
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="project_client"
//                                         className="form-labels font-weight500 announce-date"
//                                     >
//                                         Client Name<span className="required">*</span>
//                                     </label>
//                                     {clientLoading ? (
//                                         <div className="form-loader">
//                                             <div className="bar-loader"></div>
//                                         </div>
//                                     ) : (
//                                         <Select
//                                             id="project_client"
//                                             name="project_client"
//                                             options={clientOptions}
//                                             onChange={(selected) =>
//                                                 handleSelectChange("project_client", selected)
//                                             }
//                                             value={
//                                                 clientOptions.find(
//                                                     (o) => o.value === formData.project_client
//                                                 ) || null
//                                             }
//                                             placeholder="Search & Select client..."
//                                             isClearable
//                                             noOptionsMessage={() => "No clients found"}
//                                             styles={CSSForSelect}
//                                         />
//                                     )}
//                                     {errors.project_client && (
//                                         <span className="error-message font-size-text">
//                                             {errors.project_client}
//                                         </span>
//                                     )}
//                                 </div>

//                             </div>

//                             {/* Footer */}
//                             <div className="button-models">
//                                 <button
//                                     className="model-button model-button-cancel font-weight500"
//                                     onClick={handleClose}
//                                     disabled={loading}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-leave font-size-heading"
//                                     onClick={handleFormSubmit}
//                                     disabled={loading}
//                                 >
//                                     {loading ? "Updating..." : "Update"}
//                                 </button>
//                             </div>
//                             <p className="error-message font-size-text">
//                                 {isSubmitted && Object.keys(errors).length > 0 && (
//                                     Object.keys(errors).length > 5 ? (
//                                         <h5 className="text-center">Please fill all mandatory fields!</h5>
//                                     ) : (
//                                         <h6 className="text-center">
//                                             {Object.keys(errors).map((field) =>
//                                                 field.charAt(0).toUpperCase() + field.slice(1)
//                                             ).join(', ') + ' are required!'}
//                                         </h6>
//                                     )
//                                 )}
//                             </p>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const ProjectUpdate = ({ i, getProjects, SUB_COMPANIES }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [clientLoading, setClientLoading] = useState(false);
    const [departmentLists, setDepartmentLists] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [ProjectTypeLoading, setProjectTypeLoading] = useState(false);
    const [typeList, setTypeList] = useState([]);

    const subCompanyId = sessionStorage.getItem("company_id");

    const [formData, setFormData] = useState({
        project_code: "",
        project_short_name: "",
        project_full_name: "",
        project_description: "",
        project_status: "",
        project_start_date: null,
        project_end_date: null,
        project_type: "",
        project_client: "",
        department: "",
        sub_company: subCompanyId,
        created_by: sessionStorage.getItem("emp_code"),
        updated_by: sessionStorage.getItem("emp_code"),
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleShow = async () => {
        setFormData({
            project_code: i.project_code || "",
            project_short_name: i.project_short_name || "",
            project_full_name: i.project_full_name || "",
            project_type: i.project_type || "",
            project_client: i.project_client || "",
            department: i.department || "",
            sub_company: subCompanyId,
        });
        setErrors({});
        setInputState({
            project_code: i.project_code ? "green" : "",
            project_short_name: i.project_short_name ? "green" : "",
            project_full_name: i.project_full_name ? "green" : "",
            project_type: i.project_type ? "green" : "",
            project_client: i.project_client ? "green" : "",
            department: i.department ? "green" : "",
        });
        await fetchClients();
        await fetchProjectType();
        await fetchDepartments();
        setShow(true);
    };

    const handleClose = () => {
        setErrors({});
        setShow(false);
    };

    const fetchClients = async () => {
        setClientLoading(true);
        try {

            const res = await axios.get(`${BASE_URL}/mantra_projects/clientsearch/`);
            // const res = await axios.get(`${BASE_URL}/mantra_projects/clients/`);
            const data = Array.isArray(res.data) ? res.data : res.data.results || [];
            setClientList(data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setClientLoading(false);
        }
    };

    const fetchProjectType = async () => {
        setProjectTypeLoading(true);
        try {
            const res = await axios.get(`${BASE_URL}/mantra_projects/types/`);
            const data = Array.isArray(res.data) ? res.data : res.data.results || [];
            setTypeList(data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setProjectTypeLoading(false);
        }
    };

    const fetchDepartments = async () => {
        try {
            setBuffering1(true);
            const dep = await axios.get(
                `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompanyId || "null"}/active/`
            );
            setDepartmentLists(dep.data);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const fieldLabels = {
        project_code: "Project Code",
        project_short_name: "Project Short Name",
        project_full_name: "Project Full Name",
        project_type: "Project Type",
        project_client: "Client Name",
        department: "Department",
    };

    const validateForm = () => {
        const newErrors = {};
        // department and project_full_name are NOT mandatory
        const requiredFields = [
            "project_code",
            "project_short_name",
            "project_type",
            "project_client",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || String(formData[field]).trim() === "") {
                newErrors[field] = `${fieldLabels[field]} is required!`;
            }
        });

        if (formData.project_code && !/^[A-Za-z0-9\-_/]+$/.test(formData.project_code)) {
            newErrors.project_code =
                "Project Code can only contain letters, numbers, hyphens, underscores, or slashes.";
        }

        // if (formData.project_short_name && formData.project_short_name.length > 100) {
        //     newErrors.project_short_name = "Short Name must be under 100 characters.";
        // }

        // if (formData.project_full_name && formData.project_full_name.length > 500) {
        //     newErrors.project_full_name = "Full Name must be under 500 characters.";
        // }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
        setFormData({ ...formData, [name]: value });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSelectChange = (name, selectedOption) => {
        const value =
            selectedOption && typeof selectedOption === "object"
                ? selectedOption.value
                : selectedOption || "";
        setInputState({ ...inputState, [name]: value ? "green" : "" });
        setFormData({ ...formData, [name]: value });
        if ((value || "").trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        const loadingToastId = toast.loading("Updating project, please wait...");
        try {
            const payload = {
                ...formData,
                sub_company: subCompanyId,
                updated_by: sessionStorage.getItem("emp_code"),
            };
            const res = await axios.put(`${BASE_URL}/mantra_projects/projects/${i.id}/`, payload);
            if (res.status === 200 || res.status === 201) {
                toast.dismiss(loadingToastId);
                toast.success("Project updated successfully!");
                if (getProjects) await getProjects();
                handleClose();
            } else {
                alert(res);
            }
        } catch (err) {
            handleAllError(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const clientOptions = clientList.map((client) => ({
        value: client.id,
        label: client.client_name,
    }));

    const projectTypeOptions = typeList.map((type) => ({
        value: type.id,
        label: type.type_name,
    }));

    return (
        <>
            <button title="Update Project" className="model-edit-button" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Update Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap">

                                {/* Department — optional */}
                                <div className="flex-column">
                                    <label htmlFor="department" className="form-labels font-weight500 announce-date">
                                        Department
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <select
                                            name="department"
                                            onChange={(e) =>
                                                handleSelectChange("department", {
                                                    value: e.target.value,
                                                    label: e.target.options[e.target.selectedIndex].text,
                                                })
                                            }
                                            value={formData.department}
                                            className="form-input form-input-background"
                                        >
                                            <option value="">Select Department for Projects</option>
                                            {sessionStorage.getItem("company_id") === "025d0b52-e892-4868-a3bb-6b70dcdffb4d" && (
                                                <option value="Prebid">Prebid</option>
                                            )}
                                            {departmentLists
                                                .sort((a, b) => a.title - b.title)
                                                .map((i, index) => (
                                                    <option key={index} value={i.id}>{i.title}</option>
                                                ))}
                                        </select>
                                    )}
                                    {errors.department && (
                                        <span className="error-message font-size-text">{errors.department}</span>
                                    )}
                                </div>

                                {/* Project Code */}
                                <div className="flex-column">
                                    <label htmlFor="project_code" className="form-labels font-weight500 announce-date">
                                        Project Code<span className="required">*</span>
                                    </label>
                                    <input
                                        id="project_code"
                                        type="text"
                                        name="project_code"
                                        placeholder="e.g. CSMS-001"
                                        onChange={handleInputChange}
                                        value={formData.project_code}
                                        className={`form-input ${errors.project_code ? "error" : inputState.project_code ? "success" : ""}`}
                                    />
                                    {errors.project_code && (
                                        <span className="error-message font-size-text">{errors.project_code}</span>
                                    )}
                                </div>

                                {/* Project Short Name */}
                                <div className="flex-column">
                                    <label htmlFor="project_short_name" className="form-labels font-weight500 announce-date">
                                        Project Short Name<span className="required">*</span>
                                    </label>
                                    <input
                                        id="project_short_name"
                                        type="text"
                                        name="project_short_name"
                                        placeholder="e.g. CSMS Phase 1"
                                        onChange={handleInputChange}
                                        value={formData.project_short_name}
                                        className={`form-input ${errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""}`}
                                    />
                                    {errors.project_short_name && (
                                        <span className="error-message font-size-text">{errors.project_short_name}</span>
                                    )}
                                </div>

                                {/* Project Full Name — optional */}
                                <div className="flex-column">
                                    <label htmlFor="project_full_name" className="form-labels font-weight500 announce-date">
                                        Project Full Name
                                    </label>
                                    <input
                                        id="project_full_name"
                                        type="text"
                                        name="project_full_name"
                                        placeholder="e.g. Centralized Monitoring System Phase 1 - Delhi"
                                        onChange={handleInputChange}
                                        value={formData.project_full_name}
                                        className={`form-input ${errors.project_full_name ? "error" : inputState.project_full_name ? "success" : ""}`}
                                    />
                                    {errors.project_full_name && (
                                        <span className="error-message font-size-text">{errors.project_full_name}</span>
                                    )}
                                </div>

                                {/* Project Type */}
                                <div className="flex-column">
                                    <label htmlFor="project_type" className="form-labels font-weight500 announce-date">
                                        Project Type<span className="required">*</span>
                                    </label>
                                    {ProjectTypeLoading ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <Select
                                            id="project_type"
                                            name="project_type"
                                            options={projectTypeOptions}
                                            onChange={(selected) => handleSelectChange("project_type", selected)}
                                            value={projectTypeOptions.find((o) => o.value === formData.project_type) || null}
                                            placeholder="Select Project Type"
                                            isClearable
                                            styles={CSSForSelect}
                                        />
                                    )}
                                    {errors.project_type && (
                                        <span className="error-message font-size-text">{errors.project_type}</span>
                                    )}
                                </div>

                                {/* Client Name */}
                                <div className="flex-column">
                                    <label htmlFor="project_client" className="form-labels font-weight500 announce-date">
                                        Client Name<span className="required">*</span>
                                    </label>
                                    {clientLoading ? (
                                        <div className="form-loader"><div className="bar-loader"></div></div>
                                    ) : (
                                        <Select
                                            id="project_client"
                                            name="project_client"
                                            options={clientOptions}
                                            onChange={(selected) => handleSelectChange("project_client", selected)}
                                            value={clientOptions.find((o) => o.value === formData.project_client) || null}
                                            placeholder="Search & Select client..."
                                            isClearable
                                            noOptionsMessage={() => "No clients found"}
                                            styles={CSSForSelect}
                                        />
                                    )}
                                    {errors.project_client && (
                                        <span className="error-message font-size-text">{errors.project_client}</span>
                                    )}
                                </div>

                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Update"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(", ") + " are required!"}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const ProjectDelete = ({ i, getProjects }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();

        const loadingToastId = toast.loading("Loading:   Please wait...");
        try {
            let res = await axios.delete(`${BASE_URL}/mantra_projects/projects/${i.id}/`);

            if (res.status === 200) {
                setShow(false);
                toast.success("Project Deleted Successfully!");
                await getProjects();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Project"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete this Project</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete project{" "}
                        <b>{i.project_code} - {i.project_short_name}</b>?
                        <div className="button-models">
                            <button
                                className="model-button font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button font-weight500 model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ===================== ADD MODAL =====================
const ProjectTypeAdd = ({ getProjectTypeList }) => {
    const [show, setShow] = useState(false);
    const initialForm = {
        type_name: "",
        type_description: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    };
    const [formData, setFormData] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});

    const handleShow = () => {
        setFormData(initialForm);
        setErrors({});
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
        setFormData(initialForm);
        setErrors({});
        setInputState({});
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.type_name.trim()) newErrors.type_name = "Type name is required.";
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const payload = {
                ...formData,
                created_at: new Date().toISOString(),
            };
            let res = await axios.post(`${BASE_URL}/mantra_projects/types/`, payload);
            if (res.status === 200 || res.status === 201) {
                await getProjectTypeList();
                setShow(false);
                setFormData(formData);
                toast.success("Project Type added successfully!")
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Add Project Type">
                <AddwithWhiteCircle />{" "}Project Type
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Project Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap" style={{ gap: '0px' }}>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="type_name">
                                        Project Type Name <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="type_name"
                                        name="type_name"
                                        placeholder="Enter type name"
                                        value={formData.type_name}
                                        onChange={handleChange}
                                        className={`form-input ${errors.type_name ? "error" : ""}`}
                                    />
                                    {errors.type_name && (
                                        <span className="error-message font-size-text">{errors.type_name}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="type_description">
                                        Description
                                    </label>
                                    <textarea
                                        id="type_description"
                                        name="type_description"
                                        placeholder="Enter description"
                                        value={formData.type_description}
                                        onChange={handleChange}
                                        rows={3}
                                        className="form-input-textarea"
                                    />
                                </div>
                            </div>
                            {/* Footer */}
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose} disabled={loading}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button model-button-submit font-weight500 font-size-subheading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Adding..." : "Add"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


// ===================== UPDATE MODAL =====================
const ProjectTypeUpdate = ({ i, getProjectTypeList }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        type_name: "",
        type_description: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});

    const handleShow = () => {
        setFormData({
            type_name: i.type_name || "",
            type_description: i.type_description || "",
        });
        setErrors({});
        setShow(true);
    };
    const handleClose = () => {
        setErrors({});
        setFormData(formData);
        setShow(false);
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.type_name.trim()) newErrors.type_name = "Type name is required.";
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const payload = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
            };
            let res = await axios.put(`${BASE_URL}/mantra_projects/types/${i.id}/`, payload);
            if (res.status === 200) {
                await getProjectTypeList();
                setShow(false);
                toast.success("Project Type updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-edit-button-ml" onClick={handleShow} title="Update Project Type">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Project Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap" style={{ gap: '0px' }}>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="type_name_edit">
                                        Project Type Name <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="type_name_edit"
                                        name="type_name"
                                        placeholder="Enter type name"
                                        value={formData.type_name}
                                        onChange={handleChange}
                                        className={`form-input ${errors.type_name ? "error" : ""}`}
                                    />
                                    {errors.type_name && (
                                        <span className="error-message font-size-text">{errors.type_name}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="type_description_edit">
                                        Description
                                    </label>
                                    <textarea
                                        id="type_description_edit"
                                        name="type_description"
                                        placeholder="Enter description"
                                        value={formData.type_description}
                                        onChange={handleChange}
                                        rows={3}
                                        className="form-input-textarea"
                                    />
                                </div>
                            </div>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button model-button-submit font-weight500 font-size-subheading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Update"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>

            </Modal>
        </>
    );
};


// ===================== DELETE MODAL =====================
const ProjectTypeDelete = ({ i, getProjectTypeList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = await axios.delete(`${BASE_URL}/mantra_projects/types/${i.id}/`);
            if (res.status === 200) {
                await getProjectTypeList();
                setShow(false);
                toast.success("Project Type Deleted Successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Project Type"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-30vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Project Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete project type{" "}
                        <strong>"{i.type_name}"</strong>?
                        <div className="button-models">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                className="model-button model-button-delete font-weight500 font-size-subheading"
                                onClick={handleDelete}
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



// ===================== ADD MODAL =====================
const ProjectClientAdd = ({ getProjectClientList }) => {
    const [show, setShow] = useState(false);
    const initialForm = {
        client_name: "",
        client_state: "",
        client_ro: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    };
    const [formData, setFormData] = useState(initialForm);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [inputState, setInputState] = useState({});

    const handleShow = () => {
        setFormData(initialForm);
        setErrors({});
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
        setFormData(initialForm);
        setErrors({});
        setInputState({});
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.client_name.trim()) newErrors.client_name = "Client name is required.";
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const payload = {
                ...formData,
                created_at: new Date().toISOString(),
            };
            let res = await axios.post(`${BASE_URL}/mantra_projects/clients/`, payload);
            if (res.status === 200 || res.status === 201) {
                await getProjectClientList();
                setShow(false);
                setFormData(formData);
                toast.success("Project Client added successfully!")

            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>

            <button className="upload-svg" onClick={handleShow} title="Add Project Client">
                <AddwithWhiteCircle />{" "}Project Client
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Project Client</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap" style={{ gap: '0px' }}>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_name">
                                        Client Name <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="client_name"
                                        name="client_name"
                                        placeholder="Enter client name"
                                        value={formData.client_name}
                                        onChange={handleChange}
                                        className={`form-input ${errors.client_name ? "error" : ""}`}
                                    />
                                    {errors.client_name && (
                                        <span className="error-message font-size-text">{errors.client_name}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_state">
                                        State
                                    </label>
                                    <input
                                        type="text"
                                        id="client_state"
                                        name="client_state"
                                        placeholder="Enter state"
                                        value={formData.client_state}
                                        onChange={handleChange}
                                        className="form-input"
                                    />
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_ro">
                                        RO
                                    </label>
                                    <input
                                        type="text"
                                        id="client_ro"
                                        name="client_ro"
                                        placeholder="Enter RO"
                                        value={formData.client_ro}
                                        onChange={handleChange}
                                        className="form-input"
                                    />
                                </div>
                            </div>
                            {/* Footer */}
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button model-button-submit font-weight500 font-size-subheading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Adding..." : "Add"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>


                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>

            </Modal>
        </>
    );
};


// ===================== UPDATE MODAL =====================
const ProjectClientUpdate = ({ i, getProjectClientList }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        client_name: "",
        client_state: "",
        client_ro: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false);

    const handleShow = () => {
        setFormData({
            client_name: i.client_name || "",
            client_state: i.client_state || "",
            client_ro: i.client_ro || "",
        });
        setErrors({});
        setShow(true);
    };
    const handleClose = () => {
        setErrors({});
        setFormData(formData);
        setShow(false);
    }

    const validate = () => {
        const newErrors = {};
        if (!formData.client_name.trim()) newErrors.client_name = "Client name is required.";
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const payload = {
                ...formData,
                updated_by: sessionStorage.getItem('emp_code'),
            };
            let res = await axios.put(`${BASE_URL}/mantra_projects/clients/${i.id}/`, payload);
            if (res.status === 200) {
                await getProjectClientList();
                setShow(false);
                toast.success("Project Client updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-edit-button-ml" onClick={handleShow} title="Update Project Client">
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Project Client</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap" style={{ gap: '0px' }}>
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_name_edit">
                                        Client Name <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="client_name_edit"
                                        name="client_name"
                                        placeholder="Enter client name"
                                        value={formData.client_name}
                                        onChange={handleChange}
                                        className={`form-input ${errors.client_name ? "error" : ""}`}
                                    />
                                    {errors.client_name && (
                                        <span className="error-message font-size-text">{errors.client_name}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_state_edit">
                                        State
                                    </label>
                                    <input
                                        type="text"
                                        id="client_state_edit"
                                        name="client_state"
                                        placeholder="Enter state"
                                        value={formData.client_state}
                                        onChange={handleChange}
                                        className="form-input"
                                    />
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading" htmlFor="client_ro_edit">
                                        RO
                                    </label>
                                    <input
                                        type="text"
                                        id="client_ro_edit"
                                        name="client_ro"
                                        placeholder="Enter RO"
                                        value={formData.client_ro}
                                        onChange={handleChange}
                                        className="form-input"
                                    />
                                </div>
                            </div>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button model-button-submit font-weight500 font-size-subheading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Updating..." : "Update"}
                                </button>
                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        <h6 className="text-center">
                                            {Object.keys(errors).map((field) =>
                                                field.charAt(0).toUpperCase() + field.slice(1)
                                            ).join(', ') + ' are required!'}
                                        </h6>
                                    )
                                )}
                            </p>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>

            </Modal>
        </>
    );
};


// ===================== DELETE MODAL =====================
const ProjectClientDelete = ({ i, getProjectClientList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = await axios.delete(`${BASE_URL}/mantra_projects/clients/${i.id}/`);
            if (res.status === 200) {
                await getProjectClientList();
                setShow(false);
                toast.success("Project Client Deleted Successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Project Client"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-30vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Project Client</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete client{" "}
                        <strong>"{i.client_name}"</strong>?
                        <div className="button-models">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                className="model-button model-button-delete font-weight500 font-size-subheading"
                                onClick={handleDelete}
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

// ===================== PROJECT TYPE BULK UPLOAD COMPONENT =====================


// const ProjectTypeBulkUpload = ({ getProjectTypeList }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [fileData, setFileData] = useState(null);
//     const [fileName, setFileName] = useState("");
//     const [fileSize, setFileSize] = useState("");
//     const [preview, setPreview] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [isDragOver, setIsDragOver] = useState(false);
//     const [uploadDone, setUploadDone] = useState(false);

//     const handleShow = () => {
//         setShow(true);
//         setFileData(null); setFileName(""); setFileSize("");
//         setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
//     };
//     const handleClose = () => { setShow(false); };

//     const parseCSV = (csvText) => {
//         const lines = csvText.trim().split('\n');
//         if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");

//         const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
//         const typeNameIndex = headers.indexOf('type_name');
//         const descIndex = headers.indexOf('type_description');

//         if (typeNameIndex === -1) throw new Error("CSV must contain a 'type_name' column");

//         const data = [];
//         for (let i = 1; i < lines.length; i++) {
//             if (lines[i].trim() === '') continue;
//             const values = lines[i].split(',').map(v => v.trim());
//             const item = {
//                 type_name: values[typeNameIndex] || "",
//                 type_description: descIndex !== -1 ? values[descIndex] || "" : ""
//             };
//             if (item.type_name) data.push(item);
//         }
//         return data;
//     };

//     const parseExcel = (arrayBuffer) => {
//         const workbook = XLSX.read(arrayBuffer, { type: 'array' });
//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         const data = XLSX.utils.sheet_to_json(worksheet);

//         if (!Array.isArray(data) || data.length === 0)
//             throw new Error("Excel sheet is empty or invalid");

//         const mapped = data.map(row => {
//             const lk = Object.keys(row).reduce((acc, k) => { acc[k.toLowerCase()] = row[k]; return acc; }, {});
//             return {
//                 type_name: lk['type_name'] || lk['typename'] || "",
//                 type_description: lk['type_description'] || lk['typedescription'] || lk['description'] || ""
//             };
//         }).filter(item => item.type_name);

//         if (mapped.length === 0)
//             throw new Error("No valid rows with 'type_name' found in Excel sheet");

//         return mapped;
//     };

//     const processFile = async (file) => {
//         if (!file) return;
//         try {
//             let parsedData = [];
//             if (file.name.endsWith('.csv')) {
//                 const text = await file.text();
//                 parsedData = parseCSV(text);
//             } else if (file.name.endsWith('.json')) {
//                 const text = await file.text();
//                 parsedData = JSON.parse(text);
//                 if (!Array.isArray(parsedData)) throw new Error("JSON must be an array");
//             } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
//                 const buf = await file.arrayBuffer();
//                 parsedData = parseExcel(buf);
//             } else {
//                 throw new Error("Only CSV, JSON, or Excel files are supported");
//             }
//             setFileData(parsedData);
//             setFileName(file.name);
//             setFileSize((file.size / 1024).toFixed(1) + " KB");
//             setPreview(parsedData);
//             setErrors({});
//         } catch (err) {
//             setErrors({ file: err.message });
//         }
//     };

//     // const handleSubmit = async () => {
//     //     try {
//     //         setLoading(true);
//     //         toast.loading("Uploading...");
//     //         const payload = fileData.map(item => ({
//     //             ...item,
//     //             created_by: sessionStorage.getItem('emp_code'),
//     //             updated_by: sessionStorage.getItem('emp_code'),
//     //         }));
//     //         const res = await axios.post(`${BASE_URL}/mantra_projects/typeBulkCreate/`, payload);
//     //         if (res.status === 200 || res.status === 201) {
//     //             await getProjectTypeList();
//     //             setUploadDone(true);
//     //             toast.success(`${fileData.length} project types uploaded!`);
//     //             setTimeout(handleClose, 1500);
//     //         }
//     //     } catch (err) {
//     //         handleErrorToast(err);
//     //         toast.error(err)
//     //     } finally {
//     //         setLoading(false);
//     //         toast.dismiss();
//     //     }
//     // };

//     const handleSubmit = async () => {
//         try {
//             setLoading(true);
//             toast.loading("Uploading...");
//             const payload = fileData.map(item => ({
//                 ...item,
//                 created_by: sessionStorage.getItem('emp_code'),
//                 updated_by: sessionStorage.getItem('emp_code'),
//             }));
//             const res = await axios.post(`${BASE_URL}/mantra_projects/typeBulkCreate/`, payload);

//             if (res.status === 200 || res.status === 201) {
//                 // Check if API returned validation errors
//                 if (res.data?.errors && res.data.errors.length > 0) {
//                     toast.dismiss();

//                     // Parse each error object: { rowIndex: { field: [messages] } }
//                     const errorMessages = res.data.errors.flatMap(errObj =>
//                         Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                             Object.entries(fields).flatMap(([field, messages]) =>
//                                 messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                             )
//                         )
//                     );

//                     // Show each unique error as a separate toast
//                     errorMessages.forEach((msg, i) => {
//                         setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150);
//                     });

//                     return;
//                 }

//                 await getProjectTypeList();
//                 setUploadDone(true);
//                 toast.success(`${fileData.length} project types uploaded!`);
//                 setTimeout(handleClose, 1500);
//             }
//         } catch (err) {
//             toast.dismiss();

//             // Also handle if the API throws with error response body
//             const apiErrors = err?.response?.data?.errors;
//             if (apiErrors && apiErrors.length > 0) {
//                 const errorMessages = apiErrors.flatMap(errObj =>
//                     Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                         Object.entries(fields).flatMap(([field, messages]) =>
//                             messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                         )
//                     )
//                 );
//                 errorMessages.forEach((msg, i) => {
//                     setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150);
//                 });
//             } else {
//                 handleErrorToast(err);
//             }
//         } finally {
//             setLoading(false);
//             toast.dismiss();
//         }
//     };

//     return (
//         <>
//             <button className="upload-svg" onClick={handleShow}>
//                 <AddwithWhiteCircle /> Bulk Upload
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
//                 <Modal.Header closeButton>
//                     <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                         <div style={{
//                             width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
//                             display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
//                         }}>
//                             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                             </svg>
//                         </div>
//                         <div>
//                             <Modal.Title style={{ fontSize: 15, fontWeight: 500, marginBottom: 2 }}>
//                                 Bulk Upload Project Types
//                             </Modal.Title>

//                         </div>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body>
//                     {/* Format Badges */}
//                     <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
//                         {[
//                             { label: "Excel .xlsx", color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
//                             // { label: "CSV", color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
//                             // { label: "JSON", color: "#854F0B", bg: "#FAEEDA", border: "#EF9F27" },
//                         ].map(f => (
//                             <span key={f.label} style={{
//                                 padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
//                                 background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
//                             }}>{f.label}</span>
//                         ))}
//                         <span style={{ fontSize: 11, color: "#aaa", alignSelf: "center" }}>
//                             Required: type_name, type_description
//                         </span>
//                     </div>

//                     {/* Drop Zone */}
//                     <div
//                         onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
//                         onDragLeave={() => setIsDragOver(false)}
//                         onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
//                         style={{
//                             border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
//                             borderRadius: 10,
//                             padding: "28px 20px",
//                             textAlign: "center",
//                             background: isDragOver ? "#E6F1FB" : "var(--color-background-secondary)",
//                             cursor: "pointer",
//                             position: "relative",
//                             transition: "all 0.2s"
//                         }}
//                     >
//                         <input
//                             type="file" accept=".csv,.json,.xlsx,.xls"
//                             onChange={e => processFile(e.target.files[0])}
//                             style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}
//                         />
//                         <div style={{
//                             width: 44, height: 44, margin: "0 auto 10px",
//                             background: "white", border: "0.5px solid #e0e0e0",
//                             borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center"
//                         }}>
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                             </svg>
//                         </div>
//                         <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 3 }}>
//                             Drop your file here or click to browse
//                         </div>
//                         {/* <div style={{ fontSize: 11, color: "#aaa" }}>Maximum file size: 5 MB</div> */}
//                     </div>

//                     {/* Chosen File Chip */}
//                     {fileName && (
//                         <div style={{
//                             marginTop: 10, display: "flex", alignItems: "center", gap: 8,
//                             padding: "8px 12px", background: "white",
//                             border: "0.5px solid #ddd", borderRadius: 8
//                         }}>
//                             {/* file icon */}
//                             <span style={{ flex: 1, fontSize: 12, fontWeight: 500 }}>{fileName}</span>
//                             <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
//                             <span style={{ color: "#3B6D11", fontSize: 13 }}>✓</span>
//                         </div>
//                     )}

//                     {/* Errors */}
//                     {errors.file && (
//                         <div style={{
//                             marginTop: 10, padding: "10px 14px",
//                             background: "#FCEBEB", border: "0.5px solid #F09595",
//                             borderRadius: 8, color: "#791F1F", fontSize: 12
//                         }}>
//                             {errors.file}
//                         </div>
//                     )}

//                     {/* Preview Table */}
//                     {preview.length > 0 && (
//                         <div style={{ marginTop: 16 }}>
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
//                                 <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                                     Data Preview
//                                 </span>
//                                 <span style={{
//                                     fontSize: 11, padding: "2px 8px", background: "#EAF3DE",
//                                     color: "#3B6D11", borderRadius: 20, fontWeight: 500
//                                 }}>
//                                     {preview.length} items
//                                 </span>
//                             </div>
//                             <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
//                                 <div style={{ maxHeight: "260px", overflowY: "auto" }}>
//                                     <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                                         <thead>
//                                             <tr style={{ background: "#f7f7f7" }}>
//                                                 <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0", width: 32 }}>#</th>
//                                                 <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0" }}>Type Name</th>
//                                                 <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0" }}>Description</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {preview.map((row, i) => (
//                                                 <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
//                                                     <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
//                                                     <td style={{ padding: "7px 12px", fontWeight: 500 }}>{row.type_name}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666" }}>{row.type_description || "—"}</td>
//                                                 </tr>
//                                             ))}
//                                             {/* {preview.length > 5 && (
//                                                 <tr>
//                                                     <td colSpan={3} style={{ padding: "7px 12px", textAlign: "center", color: "#aaa", fontStyle: "italic" }}>
//                                                         +{preview.length - 5} more rows
//                                                     </td>
//                                                 </tr>
//                                             )} */}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                     <div style={{ borderTop: "0.5px solid #eee", justifyContent: "space-between", padding: "12px 24px" }}>
//                         <span style={{ fontSize: 11, color: "#aaa" }}>
//                             {preview.length > 0 ? `Ready to upload ${preview.length} project types` : "No file selected"}
//                         </span>
//                         <div style={{ display: "flex", gap: 8 }}>
//                             <button onClick={handleClose} style={{
//                                 padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                 border: "0.5px solid #ddd", background: "transparent", cursor: "pointer"
//                             }}>Cancel</button>
//                             <button
//                                 onClick={handleSubmit}
//                                 disabled={loading || preview.length === 0}
//                                 style={{
//                                     padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                     background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
//                                     color: preview.length > 0 ? "white" : "#aaa",
//                                     border: "none", cursor: preview.length > 0 ? "pointer" : "not-allowed"
//                                 }}
//                             >
//                                 {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload ${preview.length > 0 ? `${preview.length} items` : ""}`}
//                             </button>
//                         </div>
//                     </div>
//                 </Modal.Body>


//             </Modal>
//         </>
//     );
// };
const ProjectTypeBulkUpload = ({ getProjectTypeList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [preview, setPreview] = useState([]);
    const [errors, setErrors] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadDone, setUploadDone] = useState(false);

    const ALLOWED_FIELDS = ['type_name', 'type_description'];
    const REQUIRED_FIELDS = ['type_name'];

    const handleShow = () => {
        setShow(true);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
    };

    const handleClose = () => {
        setShow(false);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
    };

    // ── Download Format ───────────────────────────────────────────
    const handleDownloadFormat = () => {
        const wb = XLSX.utils.book_new();

        // Sheet 1: Template (headers only, no sample data)
        const templateHeaders = ["type_name", "type_description"];
        const templateWS = XLSX.utils.aoa_to_sheet([templateHeaders]);
        templateWS['!cols'] = [{ wch: 30 }, { wch: 50 }];
        XLSX.utils.book_append_sheet(wb, templateWS, "Type Upload Template");

        // Sheet 2: Field Instructions
        const instructionRows = [
            ["Field", "Required", "Description", "Example"],
            ["type_name", "YES ✓", "Unique name of the project type", "Highway Construction"],
            ["type_description", "NO", "Brief description of the type", "Major road and highway projects"],
        ];
        const instrWS = XLSX.utils.aoa_to_sheet(instructionRows);
        instrWS['!cols'] = [{ wch: 18 }, { wch: 12 }, { wch: 40 }, { wch: 30 }];
        XLSX.utils.book_append_sheet(wb, instrWS, "Field Instructions");

        XLSX.writeFile(wb, `Project_Type_Bulk_Upload_Format_${new Date().toISOString().split("T")[0]}.xlsx`);
        toast.success("Format downloaded successfully!");
    };

    // ── Field Validation ──────────────────────────────────────────
    const validateFields = (headers) => {
        const unknownFields = headers.filter(h => h && !ALLOWED_FIELDS.includes(h));
        if (unknownFields.length > 0) {
            throw new Error(
                `Unknown column(s) found: "${unknownFields.join('", "')}". ` +
                `Only these fields are allowed: ${ALLOWED_FIELDS.join(', ')}`
            );
        }
        const missingRequired = REQUIRED_FIELDS.filter(f => !headers.includes(f));
        if (missingRequired.length > 0) {
            throw new Error(`Missing required column(s): ${missingRequired.join(', ')}`);
        }
    };

    // ── Parsers ───────────────────────────────────────────────────
    const parseCSV = (csvText) => {
        const lines = csvText.trim().split('\n');
        if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");

        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
        validateFields(headers);

        const idx = (name) => headers.indexOf(name);
        const data = [];
        for (let i = 1; i < lines.length; i++) {
            if (lines[i].trim() === '') continue;
            const values = lines[i].split(',').map(v => v.trim());
            const item = {
                type_name: values[idx('type_name')] || "",
                type_description: idx('type_description') !== -1 ? values[idx('type_description')] || "" : "",
            };
            if (item.type_name) data.push(item);
        }
        return data;
    };

    const parseExcel = (arrayBuffer) => {
        try {
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(worksheet);

            if (!Array.isArray(data) || data.length === 0)
                throw new Error("Excel sheet is empty or invalid");

            // Validate headers
            const headers = Object.keys(data[0]).map(k => k.toLowerCase().trim());
            validateFields(headers);

            const mapped = data.map(row => {
                const lk = Object.keys(row).reduce((acc, k) => {
                    acc[k.toLowerCase().trim()] = row[k];
                    return acc;
                }, {});
                return {
                    type_name: String(lk['type_name'] || ""),
                    type_description: String(lk['type_description'] || ""),
                };
            }).filter(item => item.type_name);

            if (mapped.length === 0)
                throw new Error("No valid rows with 'type_name' found in Excel sheet");

            return mapped;
        } catch (err) {
            throw new Error(err.message);
        }
    };

    // ── Process File ──────────────────────────────────────────────
    const processFile = async (file) => {
        if (!file) return;
        setErrors({});
        try {
            let parsedData = [];
            if (file.name.endsWith('.csv')) {
                parsedData = parseCSV(await file.text());
            } else if (file.name.endsWith('.json')) {
                const parsed = JSON.parse(await file.text());
                if (!Array.isArray(parsed)) throw new Error("JSON must be an array");
                if (parsed.length > 0) {
                    const headers = Object.keys(parsed[0]).map(k => k.toLowerCase().trim());
                    validateFields(headers);
                }
                parsedData = parsed.filter(item => item.type_name);
            } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
                parsedData = parseExcel(await file.arrayBuffer());
            } else {
                throw new Error("Only CSV, JSON, or Excel files are supported");
            }
            setFileData(parsedData);
            setFileName(file.name);
            setFileSize((file.size / 1024).toFixed(1) + " KB");
            setPreview(parsedData);
        } catch (err) {
            setErrors({ file: err.message });
            setFileData(null); setFileName(""); setFileSize(""); setPreview([]);
        }
    };

    // ── Submit ────────────────────────────────────────────────────
    // const handleSubmit = async () => {
    //     if (!fileData || fileData.length === 0) return;
    //     try {
    //         setLoading(true);
    //         toast.loading("Uploading...");
    //         const payload = fileData.map(item => ({
    //             ...item,
    //             created_by: sessionStorage.getItem('emp_code'),
    //             updated_by: sessionStorage.getItem('emp_code'),
    //         }));
    //         const res = await axios.post(`${BASE_URL}/mantra_projects/typeBulkCreate/`, payload);

    //         if (res.status === 200 || res.status === 201) {
    //             if (res.data?.errors && res.data.errors.length > 0) {
    //                 toast.dismiss();
    //                 res.data.errors.flatMap(errObj =>
    //                     Object.entries(errObj).flatMap(([rowIndex, fields]) =>
    //                         Object.entries(fields).flatMap(([field, messages]) =>
    //                             messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
    //                         )
    //                     )
    //                 ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
    //                 return;
    //             }
    //             await getProjectTypeList();
    //             setUploadDone(true);
    //             toast.success(`${fileData.length} project types uploaded!`);
    //             setTimeout(handleClose, 1500);
    //         }
    //     } catch (err) {
    //         toast.dismiss();
    //         const apiErrors = err?.response?.data?.errors;
    //         if (apiErrors?.length > 0) {
    //             apiErrors.flatMap(errObj =>
    //                 Object.entries(errObj).flatMap(([rowIndex, fields]) =>
    //                     Object.entries(fields).flatMap(([field, messages]) =>
    //                         messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
    //                     )
    //                 )
    //             ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
    //         } else {
    //             handleErrorToast(err);
    //         }
    //     } finally {
    //         setLoading(false);
    //         toast.dismiss();
    //     }
    // };

    const handleSubmit = async () => {
        if (!fileData || fileData.length === 0) return;
        try {
            setLoading(true);
            toast.loading("Uploading...");
            const payload = fileData.map(item => ({
                ...item,
                created_by: sessionStorage.getItem('emp_code'),
                updated_by: sessionStorage.getItem('emp_code'),
            }));
            const res = await axios.post(`${BASE_URL}/mantra_projects/typeBulkCreate/`, payload);

            if (res.status === 200 || res.status === 201) {
                if (res.data?.errors && res.data.errors.length > 0) {
                    toast.dismiss();
                    res.data.errors.flatMap(errObj =>
                        Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
                            if (typeof fieldOrMsg === 'string') {
                                return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
                            }
                            return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
                                [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
                            );
                        })
                    ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
                    return;
                }
                await getProjectTypeList();
                setUploadDone(true);
                toast.success(`${fileData.length} project types uploaded!`);
                setTimeout(handleClose, 1500);
            }
        } catch (err) {
            toast.dismiss();
            const apiErrors = err?.response?.data?.errors;
            if (apiErrors?.length > 0) {
                apiErrors.flatMap(errObj =>
                    Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
                        if (typeof fieldOrMsg === 'string') {
                            return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
                        }
                        return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
                            [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
                        );
                    })
                ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
            } else {
                handleErrorToast(err);
            }
        } finally {
            setLoading(false);
            toast.dismiss();
        }
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Bulk Upload
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
                <Modal.Header closeButton>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                                width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                                </svg>
                            </div>
                            <div>
                                <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
                                    Bulk Upload Project Types
                                </Modal.Title>

                            </div>
                        </div>

                        {/* Download Format Button */}
                        <button
                            onClick={handleDownloadFormat}
                            style={{
                                display: "flex", alignItems: "center", gap: 6,
                                padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 500,
                                background: "#EAF3DE", color: "#3B6D11",
                                border: "0.5px solid #97C459", cursor: "pointer",
                                marginRight: 36, transition: "all 0.15s"
                            }}
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Download Format
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: "20px 24px" }}>

                    {/* Step 1 hint */}
                    <div style={{
                        padding: "10px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#FAEEDA", border: "0.5px solid #EF9F27",
                        fontSize: 12, color: "#854F0B", display: "flex", gap: 8, alignItems: "flex-start"
                    }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <div>
                            <strong>Step 1:</strong> Click <strong>"Download Format"</strong> (top right) to get the Excel template.
                            Fill in your data using only the allowed columns, then upload below.
                        </div>
                    </div>

                    {/* Allowed Fields Info */}
                    <div style={{
                        padding: "12px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#f7f9fc", border: "0.5px solid #d8e4f0"
                    }}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                            Allowed columns in your Excel
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                            {[
                                { field: "type_name", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "type_description", required: false, color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
                            ].map(f => (
                                <span key={f.field} style={{
                                    display: "inline-flex", alignItems: "center", gap: 5,
                                    padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
                                    background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
                                }}>
                                    {f.field}
                                    {f.required && (
                                        <span style={{ fontSize: 9, background: f.color, color: "white", borderRadius: 4, padding: "1px 4px" }}>
                                            required
                                        </span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <div style={{ fontSize: 10, color: "#e05c00", marginTop: 8, fontWeight: 500 }}>
                            ⚠ Adding any column not listed above will cause an error on upload.
                        </div>
                    </div>

                    {/* Drop Zone */}
                    <div
                        onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
                        onDragLeave={() => setIsDragOver(false)}
                        onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
                        style={{
                            border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
                            borderRadius: 10, padding: "24px 20px", textAlign: "center",
                            background: isDragOver ? "#E6F1FB" : "#fafafa",
                            cursor: "pointer", position: "relative", transition: "all 0.2s"
                        }}
                    >
                        <input
                            type="file" accept=".csv,.json,.xlsx,.xls"
                            onChange={e => processFile(e.target.files[0])}
                            disabled={loading}
                            style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}
                        />
                        <div style={{
                            width: 40, height: 40, margin: "0 auto 8px",
                            background: "white", border: "0.5px solid #e0e0e0",
                            borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: "#333" }}>
                            Drop your filled Excel here or click to browse
                        </div>
                        <div style={{ fontSize: 11, color: "#aaa", marginTop: 3 }}>Step 2: Upload your filled template</div>
                    </div>

                    {/* Chosen File Chip */}
                    {fileName && (
                        <div style={{
                            marginTop: 10, display: "flex", alignItems: "center", gap: 8,
                            padding: "8px 12px", background: "white",
                            border: "0.5px solid #ddd", borderRadius: 8
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            <span style={{ flex: 1, fontSize: 12, fontWeight: 500, color: "#333" }}>{fileName}</span>
                            <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2.5">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </div>
                    )}

                    {/* Error Box */}
                    {errors.file && (
                        <div style={{
                            marginTop: 10, padding: "10px 14px",
                            background: "#FCEBEB", border: "0.5px solid #F09595",
                            borderRadius: 8, color: "#791F1F", fontSize: 12,
                            display: "flex", gap: 8, alignItems: "flex-start"
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            {errors.file}
                        </div>
                    )}

                    {/* Preview Table */}
                    {preview.length > 0 && (
                        <div style={{ marginTop: 16 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Data Preview
                                </span>
                                <span style={{
                                    fontSize: 11, padding: "2px 8px", background: "#EAF3DE",
                                    color: "#3B6D11", borderRadius: 20, fontWeight: 500
                                }}>
                                    {preview.length} items
                                </span>
                            </div>
                            <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
                                <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                        <thead>
                                            <tr style={{ background: "#f7f7f7", position: "sticky", top: 0, zIndex: 1 }}>
                                                <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0", width: 32 }}>#</th>
                                                <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0" }}>Type Name</th>
                                                <th style={{ padding: "8px 12px", textAlign: "left", color: "#888", fontWeight: 500, borderBottom: "0.5px solid #e0e0e0" }}>Description</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {preview.map((row, i) => (
                                                <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
                                                    <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
                                                    <td style={{ padding: "7px 12px", fontWeight: 500, color: "#333" }}>{row.type_name}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.type_description || "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Footer */}
                    <div style={{
                        borderTop: "0.5px solid #eee", display: "flex", alignItems: "center",
                        justifyContent: "space-between", padding: "12px 0 0 0", marginTop: 16
                    }}>
                        <span style={{ fontSize: 11, color: "#aaa" }}>
                            {preview.length > 0 ? `Ready to upload ${preview.length} project types` : "No file selected"}
                        </span>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                onClick={handleClose}
                                disabled={loading}
                                style={{
                                    padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
                                    border: "0.5px solid #ddd", background: "transparent", cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={loading || preview.length === 0}
                                style={{
                                    padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
                                    background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
                                    color: preview.length > 0 ? "white" : "#aaa",
                                    border: "none",
                                    cursor: preview.length > 0 && !loading ? "pointer" : "not-allowed",
                                    transition: "background 0.2s"
                                }}
                            >
                                {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload${preview.length > 0 ? ` ${preview.length} items` : ""}`}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

// ===================== PROJECT CLIENT BULK UPLOAD COMPONENT =====================
// const ProjectClientBulkUpload = ({ getProjectClientList }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [uploadMode, setUploadMode] = useState("file"); // "file" or "paste"
//     const [fileData, setFileData] = useState("");
//     const [jsonInput, setJsonInput] = useState("[\n  {\"client_name\": \"\", \"client_state\": \"\", \"client_ro\": \"\"}\n]");
//     const [errors, setErrors] = useState({});
//     const [preview, setPreview] = useState([]);

//     const handleShow = () => {
//         setShow(true);
//         setErrors({});
//         setUploadMode("file");
//         setFileData("");
//         setJsonInput("[\n  {\"client_name\": \"\", \"client_state\": \"\", \"client_ro\": \"\"}\n]");
//         setPreview([]);
//     };

//     const handleClose = () => {
//         setShow(false);
//         setFileData("");
//         setJsonInput("[\n  {\"client_name\": \"\", \"client_state\": \"\", \"client_ro\": \"\"}\n]");
//         setErrors({});
//         setPreview([]);
//     };

//     // Parse CSV file
//     const parseCSV = (csvText) => {
//         const lines = csvText.trim().split('\n');
//         if (lines.length < 2) {
//             throw new Error("CSV must have headers and at least one data row");
//         }

//         const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
//         const clientNameIndex = headers.indexOf('client_name');
//         const clientStateIndex = headers.indexOf('client_state');
//         const clientROIndex = headers.indexOf('client_ro');

//         if (clientNameIndex === -1) {
//             throw new Error("CSV must contain 'client_name' column");
//         }

//         const data = [];
//         for (let i = 1; i < lines.length; i++) {
//             if (lines[i].trim() === '') continue;
//             const values = lines[i].split(',').map(v => v.trim());
//             const item = {
//                 client_name: values[clientNameIndex] || "",
//                 client_state: clientStateIndex !== -1 ? values[clientStateIndex] || "" : "",
//                 client_ro: clientROIndex !== -1 ? values[clientROIndex] || "" : ""
//             };
//             if (item.client_name) {
//                 data.push(item);
//             }
//         }
//         return data;
//     };

//     // Parse Excel file
//     const parseExcel = (arrayBuffer) => {
//         try {
//             const workbook = XLSX.read(arrayBuffer, { type: 'array' });
//             const sheetName = workbook.SheetNames[0];
//             const worksheet = workbook.Sheets[sheetName];
//             const data = XLSX.utils.sheet_to_json(worksheet);

//             if (!Array.isArray(data) || data.length === 0) {
//                 throw new Error("Excel sheet is empty or invalid");
//             }

//             // Map Excel columns to our required fields (case-insensitive)
//             const mappedData = data.map((row) => {
//                 const lowerKeys = Object.keys(row).reduce((acc, key) => {
//                     acc[key.toLowerCase()] = row[key];
//                     return acc;
//                 }, {});

//                 return {
//                     client_name: lowerKeys['client_name'] || lowerKeys['clientname'] || "",
//                     client_state: lowerKeys['client_state'] || lowerKeys['clientstate'] || lowerKeys['state'] || "",
//                     client_ro: lowerKeys['client_ro'] || lowerKeys['clientro'] || lowerKeys['ro'] || ""
//                 };
//             });

//             const validData = mappedData.filter(item => item.client_name);
//             if (validData.length === 0) {
//                 throw new Error("No valid rows with 'client_name' found in Excel sheet");
//             }

//             return validData;
//         } catch (err) {
//             throw new Error(`Failed to parse Excel file: ${err.message}`);
//         }
//     };

//     // Handle file upload
//     const handleFileUpload = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         try {
//             let parsedData = [];

//             if (file.name.endsWith('.csv')) {
//                 const text = await file.text();
//                 parsedData = parseCSV(text);
//             } else if (file.name.endsWith('.json')) {
//                 const text = await file.text();
//                 parsedData = JSON.parse(text);
//                 if (!Array.isArray(parsedData)) {
//                     throw new Error("JSON must be an array");
//                 }
//             } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
//                 const arrayBuffer = await file.arrayBuffer();
//                 parsedData = parseExcel(arrayBuffer);
//             } else {
//                 throw new Error("Only CSV, JSON, and Excel files (.xlsx, .xls) are supported");
//             }

//             setFileData(JSON.stringify(parsedData, null, 2));
//             setPreview(parsedData);
//             setErrors({});
//         } catch (err) {
//             setErrors({ file: err.message });
//             setFileData("");
//             setPreview([]);
//         }
//     };

//     // Validate and preview JSON input
//     const handleJsonInputChange = (value) => {
//         setJsonInput(value);
//         try {
//             const parsed = JSON.parse(value);
//             if (!Array.isArray(parsed)) {
//                 throw new Error("JSON must be an array");
//             }
//             setPreview(parsed);
//             setErrors({});
//         } catch (err) {
//             setErrors({ json: err.message });
//             setPreview([]);
//         }
//     };

//     // Validate data
//     const validateData = (data) => {
//         const newErrors = {};
//         if (!Array.isArray(data) || data.length === 0) {
//             newErrors.data = "No valid data to upload";
//             return newErrors;
//         }

//         const invalidRows = data
//             .map((item, idx) => !item.client_name ? idx + 1 : null)
//             .filter(idx => idx !== null);

//         if (invalidRows.length > 0) {
//             newErrors.data = `Rows with missing client_name: ${invalidRows.join(", ")}`;
//         }
//         return newErrors;
//     };

//     // Submit bulk upload
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const dataToUpload = uploadMode === "file"
//                 ? JSON.parse(fileData)
//                 : JSON.parse(jsonInput);

//             const validationErrors = validateData(dataToUpload);
//             if (Object.keys(validationErrors).length > 0) {
//                 setErrors(validationErrors);
//                 return;
//             }

//             setLoading(true);
//             const loadingToastId = toast.loading("Uploading: Please wait...");

//             // Add created_by and updated_by to each item
//             const payload = dataToUpload.map(item => ({
//                 ...item,
//                 created_by: sessionStorage.getItem('emp_code'),
//                 updated_by: sessionStorage.getItem('emp_code'),
//                 created_at: new Date().toISOString(),
//             }));

//             const res = await axios.post(`${BASE_URL}/mantra_projects/clientBulkCreate/`, payload);

//             if (res.status === 200 || res.status === 201) {
//                 await getProjectClientList();
//                 handleClose();
//                 toast.success(`Successfully uploaded ${dataToUpload.length} project clients!`);
//             }
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setLoading(false);
//             toast.dismiss();
//         }
//     };

//     return (
//         <>
//             <button className="upload-svg" onClick={handleShow} title="Bulk Upload Project Clients">
//                 <AddwithWhiteCircle /> Bulk Upload
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Bulk Upload Project Clients</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             {/* Upload Mode Tabs */}
//                             <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', borderBottom: '1px solid #ddd' }}>
//                                 <button
//                                     onClick={() => {
//                                         setUploadMode("file");
//                                         setErrors({});
//                                     }}
//                                     style={{
//                                         padding: '10px 20px',
//                                         border: 'none',
//                                         backgroundColor: uploadMode === 'file' ? '#007bff' : '#f0f0f0',
//                                         color: uploadMode === 'file' ? 'white' : 'black',
//                                         cursor: 'pointer',
//                                         fontWeight: '500'
//                                     }}
//                                 >
//                                     Upload File (CSV/JSON/Excel)
//                                 </button>
//                                 <button
//                                     onClick={() => {
//                                         setUploadMode("paste");
//                                         setErrors({});
//                                     }}
//                                     style={{
//                                         padding: '10px 20px',
//                                         border: 'none',
//                                         backgroundColor: uploadMode === 'paste' ? '#007bff' : '#f0f0f0',
//                                         color: uploadMode === 'paste' ? 'white' : 'black',
//                                         cursor: 'pointer',
//                                         fontWeight: '500'
//                                     }}
//                                 >
//                                     Paste JSON
//                                 </button>
//                             </div>

//                             {/* File Upload Mode */}
//                             {uploadMode === "file" && (
//                                 <div className="form-flex-wrap" style={{ gap: '15px', marginBottom: '20px' }}>
//                                     <div className="flex-column" style={{ width: '100%' }}>
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             Upload CSV, JSON, or Excel File
//                                         </label>
//                                         <input
//                                             type="file"
//                                             accept=".csv,.json,.xlsx,.xls"
//                                             onChange={handleFileUpload}
//                                             disabled={loading}
//                                             style={{
//                                                 padding: '10px',
//                                                 border: '1px solid #ddd',
//                                                 borderRadius: '4px'
//                                             }}
//                                         />
//                                         <small style={{ color: '#666', marginTop: '5px' }}>
//                                             Supported formats: CSV, JSON, Excel (.xlsx, .xls). Required columns: client_name, client_state, client_ro
//                                         </small>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* JSON Paste Mode */}
//                             {uploadMode === "paste" && (
//                                 <div className="form-flex-wrap" style={{ gap: '15px', marginBottom: '20px' }}>
//                                     <div className="flex-column" style={{ width: '100%' }}>
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             Paste JSON Data
//                                         </label>
//                                         <textarea
//                                             value={jsonInput}
//                                             onChange={(e) => handleJsonInputChange(e.target.value)}
//                                             rows={8}
//                                             className="form-input-textarea"
//                                             placeholder='[{"client_name": "ABC Corp", "client_state": "CA", "client_ro": "RO-001"}]'
//                                             disabled={loading}
//                                             style={{
//                                                 fontFamily: 'monospace',
//                                                 fontSize: '12px'
//                                             }}
//                                         />
//                                         <small style={{ color: '#666', marginTop: '5px' }}>
//                                             Paste a valid JSON array with objects containing client_name, client_state, and client_ro
//                                         </small>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Error Messages */}
//                             {Object.keys(errors).length > 0 && (
//                                 <div style={{
//                                     marginBottom: '15px',
//                                     padding: '10px',
//                                     backgroundColor: '#f8d7da',
//                                     border: '1px solid #f5c6cb',
//                                     borderRadius: '4px',
//                                     color: '#721c24'
//                                 }}>
//                                     {Object.values(errors).map((err, idx) => (
//                                         <div key={idx}>{err}</div>
//                                     ))}
//                                 </div>
//                             )}

//                             {/* Preview */}
//                             {preview.length > 0 && (
//                                 <div style={{
//                                     marginBottom: '15px',
//                                     padding: '10px',
//                                     backgroundColor: '#d4edda',
//                                     border: '1px solid #c3e6cb',
//                                     borderRadius: '4px'
//                                 }}>
//                                     <strong>Preview ({preview.length} items):</strong>
//                                     <table style={{ width: '100%', marginTop: '10px', fontSize: '12px' }}>
//                                         <thead>
//                                             <tr style={{ borderBottom: '1px solid #999' }}>
//                                                 <th style={{ textAlign: 'left', padding: '5px' }}>Client Name</th>
//                                                 <th style={{ textAlign: 'left', padding: '5px' }}>State</th>
//                                                 <th style={{ textAlign: 'left', padding: '5px' }}>RO</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {preview.slice(0, 5).map((item, idx) => (
//                                                 <tr key={idx} style={{ borderBottom: '1px solid #ddd' }}>
//                                                     <td style={{ padding: '5px' }}>{item.client_name || '-'}</td>
//                                                     <td style={{ padding: '5px' }}>{item.client_state || '-'}</td>
//                                                     <td style={{ padding: '5px' }}>{item.client_ro || '-'}</td>
//                                                 </tr>
//                                             ))}
//                                             {preview.length > 5 && (
//                                                 <tr>
//                                                     <td colSpan="3" style={{ padding: '5px', textAlign: 'center' }}>
//                                                         ... and {preview.length - 5} more
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}

//                             {/* Footer */}
//                             <div className="button-models">
//                                 <button
//                                     className="model-button model-button-cancel font-weight500"
//                                     onClick={handleClose}
//                                     disabled={loading}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     className="model-button model-button-submit font-weight500 font-size-subheading"
//                                     onClick={handleSubmit}
//                                     disabled={loading || preview.length === 0}
//                                 >
//                                     {loading ? "Uploading..." : `Upload (${preview.length} items)`}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

// const ProjectClientBulkUpload = ({ getProjectClientList }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [fileData, setFileData] = useState(null);
//     const [fileName, setFileName] = useState("");
//     const [fileSize, setFileSize] = useState("");
//     const [preview, setPreview] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [isDragOver, setIsDragOver] = useState(false);
//     const [uploadDone, setUploadDone] = useState(false);

//     const handleShow = () => {
//         setShow(true);
//         setFileData(null); setFileName(""); setFileSize("");
//         setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
//     };

//     const handleClose = () => {
//         setShow(false);
//         setFileData(null); setFileName(""); setFileSize("");
//         setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
//     };

//     const parseCSV = (csvText) => {
//         const lines = csvText.trim().split('\n');
//         if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");

//         const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
//         const clientNameIndex = headers.indexOf('client_name');
//         const clientStateIndex = headers.indexOf('client_state');
//         const clientROIndex = headers.indexOf('client_ro');

//         if (clientNameIndex === -1) throw new Error("CSV must contain a 'client_name' column");

//         const data = [];
//         for (let i = 1; i < lines.length; i++) {
//             if (lines[i].trim() === '') continue;
//             const values = lines[i].split(',').map(v => v.trim());
//             const item = {
//                 client_name: values[clientNameIndex] || "",
//                 client_state: clientStateIndex !== -1 ? values[clientStateIndex] || "" : "",
//                 client_ro: clientROIndex !== -1 ? values[clientROIndex] || "" : ""
//             };
//             if (item.client_name) data.push(item);
//         }
//         return data;
//     };

//     const parseExcel = (arrayBuffer) => {
//         try {
//             const workbook = XLSX.read(arrayBuffer, { type: 'array' });
//             const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//             const data = XLSX.utils.sheet_to_json(worksheet);

//             if (!Array.isArray(data) || data.length === 0)
//                 throw new Error("Excel sheet is empty or invalid");

//             const mapped = data.map(row => {
//                 const lk = Object.keys(row).reduce((acc, k) => { acc[k.toLowerCase()] = row[k]; return acc; }, {});
//                 return {
//                     client_name: lk['client_name'] || lk['clientname'] || "",
//                     client_state: lk['client_state'] || lk['clientstate'] || lk['state'] || "",
//                     client_ro: lk['client_ro'] || lk['clientro'] || lk['ro'] || ""
//                 };
//             }).filter(item => item.client_name);

//             if (mapped.length === 0)
//                 throw new Error("No valid rows with 'client_name' found in Excel sheet");

//             return mapped;
//         } catch (err) {
//             throw new Error(`Failed to parse Excel file: ${err.message}`);
//         }
//     };

//     const processFile = async (file) => {
//         if (!file) return;
//         setErrors({});
//         try {
//             let parsedData = [];
//             if (file.name.endsWith('.csv')) {
//                 const text = await file.text();
//                 parsedData = parseCSV(text);
//             } else if (file.name.endsWith('.json')) {
//                 const text = await file.text();
//                 parsedData = JSON.parse(text);
//                 if (!Array.isArray(parsedData)) throw new Error("JSON must be an array");
//             } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
//                 const buf = await file.arrayBuffer();
//                 parsedData = parseExcel(buf);
//             } else {
//                 throw new Error("Only CSV, JSON, or Excel files are supported");
//             }
//             setFileData(parsedData);
//             setFileName(file.name);
//             setFileSize((file.size / 1024).toFixed(1) + " KB");
//             setPreview(parsedData);
//         } catch (err) {
//             setErrors({ file: err.message });
//             setFileData(null); setFileName(""); setFileSize(""); setPreview([]);
//         }
//     };

//     // const handleSubmit = async () => {
//     //     if (!fileData || fileData.length === 0) return;
//     //     try {
//     //         setLoading(true);
//     //         toast.loading("Uploading: Please wait...");

//     //         const payload = fileData.map(item => ({
//     //             ...item,
//     //             created_by: sessionStorage.getItem('emp_code'),
//     //             updated_by: sessionStorage.getItem('emp_code'),
//     //             created_at: new Date().toISOString(),
//     //         }));

//     //         const res = await axios.post(`${BASE_URL}/mantra_projects/clientBulkCreate/`, payload);

//     //         if (res.status === 200 || res.status === 201) {
//     //             await getProjectClientList();
//     //             setUploadDone(true);
//     //             toast.success(`Successfully uploaded ${fileData.length} project clients!`);
//     //             setTimeout(handleClose, 1500);
//     //         }
//     //     } catch (err) {
//     //         handleErrorToast(err);
//     //     } finally {
//     //         setLoading(false);
//     //         toast.dismiss();
//     //     }
//     // };

//     const handleSubmit = async () => {
//         if (!fileData || fileData.length === 0) return;
//         try {
//             setLoading(true);
//             toast.loading("Uploading: Please wait...");

//             const payload = fileData.map(item => ({
//                 ...item,
//                 created_by: sessionStorage.getItem('emp_code'),
//                 updated_by: sessionStorage.getItem('emp_code'),
//                 created_at: new Date().toISOString(),
//             }));

//             const res = await axios.post(`${BASE_URL}/mantra_projects/clientBulkCreate/`, payload);

//             if (res.status === 200 || res.status === 201) {
//                 if (res.data?.errors && res.data.errors.length > 0) {
//                     toast.dismiss();

//                     const errorMessages = res.data.errors.flatMap(errObj =>
//                         Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                             Object.entries(fields).flatMap(([field, messages]) =>
//                                 messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                             )
//                         )
//                     );

//                     errorMessages.forEach((msg, i) => {
//                         setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150);
//                     });

//                     return;
//                 }

//                 await getProjectClientList();
//                 setUploadDone(true);
//                 toast.success(`Successfully uploaded ${fileData.length} project clients!`);
//                 setTimeout(handleClose, 1500);
//             }
//         } catch (err) {
//             toast.dismiss();

//             const apiErrors = err?.response?.data?.errors;
//             if (apiErrors && apiErrors.length > 0) {
//                 const errorMessages = apiErrors.flatMap(errObj =>
//                     Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                         Object.entries(fields).flatMap(([field, messages]) =>
//                             messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                         )
//                     )
//                 );
//                 errorMessages.forEach((msg, i) => {
//                     setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150);
//                 });
//             } else {
//                 handleErrorToast(err);
//             }
//         } finally {
//             setLoading(false);
//             toast.dismiss();
//         }
//     };


//     const formatBadges = [
//         { label: "Excel .xlsx", color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
//         // { label: "CSV", color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
//         // { label: "JSON", color: "#854F0B", bg: "#FAEEDA", border: "#EF9F27" },
//     ];

//     return (
//         <>
//             <button className="upload-svg" onClick={handleShow} title="Bulk Upload Project Clients">
//                 <AddwithWhiteCircle /> Bulk Upload
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
//                 <Modal.Header closeButton>
//                     <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                         <div style={{
//                             width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
//                             display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
//                         }}>
//                             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                             </svg>
//                         </div>
//                         <div>
//                             <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
//                                 Bulk Upload Project Clients
//                             </Modal.Title>

//                         </div>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body style={{ padding: "20px 24px" }}>

//                     {/* Format Badges */}
//                     <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
//                         {formatBadges.map(f => (
//                             <span key={f.label} style={{
//                                 padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
//                                 background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
//                             }}>
//                                 {f.label}
//                             </span>
//                         ))}
//                         <span style={{ fontSize: 11, color: "#aaa" }}>
//                             Required: client_name &nbsp;·&nbsp; Optional: client_state, client_ro
//                         </span>
//                     </div>

//                     {/* Drop Zone */}
//                     <div
//                         onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
//                         onDragLeave={() => setIsDragOver(false)}
//                         onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
//                         style={{
//                             border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
//                             borderRadius: 10,
//                             padding: "28px 20px",
//                             textAlign: "center",
//                             background: isDragOver ? "#E6F1FB" : "#fafafa",
//                             cursor: "pointer",
//                             position: "relative",
//                             transition: "all 0.2s"
//                         }}
//                     >
//                         <input
//                             type="file"
//                             accept=".csv,.json,.xlsx,.xls"
//                             onChange={e => processFile(e.target.files[0])}
//                             disabled={loading}
//                             style={{
//                                 position: "absolute", inset: 0, opacity: 0,
//                                 cursor: "pointer", width: "100%", height: "100%"
//                             }}
//                         />
//                         <div style={{
//                             width: 44, height: 44, margin: "0 auto 10px",
//                             background: "white", border: "0.5px solid #e0e0e0",
//                             borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center"
//                         }}>
//                             <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                             </svg>
//                         </div>
//                         <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 3, color: "#333" }}>
//                             Drop your file here or click to browse
//                         </div>
//                         {/* <div style={{ fontSize: 11, color: "#aaa" }}>Maximum file size: 5 MB</div> */}
//                     </div>

//                     {/* Chosen File Chip */}
//                     {fileName && (
//                         <div style={{
//                             marginTop: 10, display: "flex", alignItems: "center", gap: 8,
//                             padding: "8px 12px", background: "white",
//                             border: "0.5px solid #ddd", borderRadius: 8
//                         }}>
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2">
//                                 <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                                 <polyline points="14 2 14 8 20 8" />
//                             </svg>
//                             <span style={{ flex: 1, fontSize: 12, fontWeight: 500, color: "#333" }}>{fileName}</span>
//                             <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2.5">
//                                 <polyline points="20 6 9 17 4 12" />
//                             </svg>
//                         </div>
//                     )}

//                     {/* Error Box */}
//                     {errors.file && (
//                         <div style={{
//                             marginTop: 10, padding: "10px 14px",
//                             background: "#FCEBEB", border: "0.5px solid #F09595",
//                             borderRadius: 8, color: "#791F1F", fontSize: 12
//                         }}>
//                             {errors.file}
//                         </div>
//                     )}

//                     {/* Preview Table */}
//                     {preview.length > 0 && (
//                         <div style={{ marginTop: 16 }}>
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
//                                 <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                                     Data Preview
//                                 </span>
//                                 <span style={{
//                                     fontSize: 11, padding: "2px 8px", background: "#EAF3DE",
//                                     color: "#3B6D11", borderRadius: 20, fontWeight: 500
//                                 }}>
//                                     {preview.length} item{preview.length !== 1 ? "s" : ""}
//                                 </span>
//                             </div>
//                             <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
//                                 <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                                     <thead>
//                                         <tr style={{ background: "#f7f7f7" }}>
//                                             {["#", "Client Name", "State", "RO"].map(h => (
//                                                 <th key={h} style={{
//                                                     padding: "8px 12px", textAlign: "left",
//                                                     color: "#888", fontWeight: 500,
//                                                     borderBottom: "0.5px solid #e0e0e0"
//                                                 }}>{h}</th>
//                                             ))}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {preview.slice(0, 5).map((row, i) => (
//                                             <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
//                                                 <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
//                                                 <td style={{ padding: "7px 12px", fontWeight: 500, color: "#333" }}>{row.client_name}</td>
//                                                 <td style={{ padding: "7px 12px", color: "#666" }}>{row.client_state || "—"}</td>
//                                                 <td style={{ padding: "7px 12px", color: "#666" }}>{row.client_ro || "—"}</td>
//                                             </tr>
//                                         ))}
//                                         {preview.length > 5 && (
//                                             <tr>
//                                                 <td colSpan={4} style={{
//                                                     padding: "7px 12px", textAlign: "center",
//                                                     color: "#aaa", fontStyle: "italic", fontSize: 11
//                                                 }}>
//                                                     +{preview.length - 5} more rows
//                                                 </td>
//                                             </tr>
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     )}
//                     <div style={{ borderTop: "0.5px solid #eee", justifyContent: "space-between", padding: "12px 24px" }}>
//                         <span style={{ fontSize: 11, color: "#aaa" }}>
//                             {preview.length > 0
//                                 ? `Ready to upload ${preview.length} project client${preview.length !== 1 ? "s" : ""}`
//                                 : "No file selected"}
//                         </span>
//                         <div style={{ display: "flex", gap: 8 }}>
//                             <button
//                                 onClick={handleClose}
//                                 disabled={loading}
//                                 style={{
//                                     padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                     border: "0.5px solid #ddd", background: "transparent", cursor: "pointer"
//                                 }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleSubmit}
//                                 disabled={loading || preview.length === 0}
//                                 style={{
//                                     padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                     background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
//                                     color: preview.length > 0 ? "white" : "#aaa",
//                                     border: "none",
//                                     cursor: preview.length > 0 && !loading ? "pointer" : "not-allowed",
//                                     transition: "background 0.2s"
//                                 }}
//                             >
//                                 {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload${preview.length > 0 ? ` ${preview.length} items` : ""}`}
//                             </button>
//                         </div>
//                     </div>
//                 </Modal.Body>

//             </Modal>
//         </>
//     );
// };
const ProjectClientBulkUpload = ({ getProjectClientList }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [preview, setPreview] = useState([]);
    const [errors, setErrors] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadDone, setUploadDone] = useState(false);

    const ALLOWED_FIELDS = ['client_name', 'client_state', 'client_ro'];
    const REQUIRED_FIELDS = ['client_name'];

    const handleShow = () => {
        setShow(true);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
    };

    const handleClose = () => {
        setShow(false);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
    };

    // ── Download Format ───────────────────────────────────────────
    const handleDownloadFormat = () => {
        const wb = XLSX.utils.book_new();

        // Sheet 1: Template with sample data
        const templateHeaders = ["client_name", "client_state", "client_ro"];
        // const sampleRows = [
        //     ["ABC Infrastructure Ltd", "Delhi", "RO-DL-001"],
        //     ["NHAI", "Haryana", "RO-HR-002"],
        //     ["Haryana Urban Dev Auth", "Haryana", "RO-HR-003"],
        // ];
        // const templateWS = XLSX.utils.aoa_to_sheet([templateHeaders, ...sampleRows]);
        const templateWS = XLSX.utils.aoa_to_sheet([templateHeaders]);
        templateWS['!cols'] = [{ wch: 35 }, { wch: 20 }, { wch: 20 }];
        XLSX.utils.book_append_sheet(wb, templateWS, "Client Upload Template");

        // Sheet 2: Field Instructions
        const instructionRows = [
            ["Field", "Required", "Description", "Example"],
            ["client_name", "YES ✓", "Full legal name of the client", "ABC Infrastructure Ltd"],
            ["client_state", "NO", "State where client is located", "Delhi"],
            ["client_ro", "NO", "Regional Office code or identifier", "RO-DL-001"],
        ];
        const instrWS = XLSX.utils.aoa_to_sheet(instructionRows);
        instrWS['!cols'] = [{ wch: 16 }, { wch: 12 }, { wch: 40 }, { wch: 28 }];
        XLSX.utils.book_append_sheet(wb, instrWS, "Field Instructions");

        XLSX.writeFile(wb, `Project_Client_Bulk_Upload_Format_${new Date().toISOString().split("T")[0]}.xlsx`);
        toast.success("Format downloaded successfully!");
    };

    // ── Field Validation ──────────────────────────────────────────
    const validateFields = (headers) => {
        const unknownFields = headers.filter(h => h && !ALLOWED_FIELDS.includes(h));
        if (unknownFields.length > 0) {
            throw new Error(
                `Unknown column(s) found: "${unknownFields.join('", "')}". ` +
                `Only these fields are allowed: ${ALLOWED_FIELDS.join(', ')}`
            );
        }
        const missingRequired = REQUIRED_FIELDS.filter(f => !headers.includes(f));
        if (missingRequired.length > 0) {
            throw new Error(`Missing required column(s): ${missingRequired.join(', ')}`);
        }
    };

    // ── Parsers ───────────────────────────────────────────────────
    const parseCSV = (csvText) => {
        const lines = csvText.trim().split('\n');
        if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");

        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
        validateFields(headers);

        const idx = (name) => headers.indexOf(name);
        const data = [];
        for (let i = 1; i < lines.length; i++) {
            if (lines[i].trim() === '') continue;
            const values = lines[i].split(',').map(v => v.trim());
            const item = {
                client_name: values[idx('client_name')] || "",
                client_state: idx('client_state') !== -1 ? values[idx('client_state')] || "" : "",
                client_ro: idx('client_ro') !== -1 ? values[idx('client_ro')] || "" : "",
            };
            if (item.client_name) data.push(item);
        }
        return data;
    };

    const parseExcel = (arrayBuffer) => {
        try {
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(worksheet);

            if (!Array.isArray(data) || data.length === 0)
                throw new Error("Excel sheet is empty or invalid");

            // Validate headers from first row keys
            const headers = Object.keys(data[0]).map(k => k.toLowerCase().trim());
            validateFields(headers);

            const mapped = data.map(row => {
                const lk = Object.keys(row).reduce((acc, k) => {
                    acc[k.toLowerCase().trim()] = row[k];
                    return acc;
                }, {});
                return {
                    client_name: String(lk['client_name'] || ""),
                    client_state: String(lk['client_state'] || ""),
                    client_ro: String(lk['client_ro'] || ""),
                };
            }).filter(item => item.client_name);

            if (mapped.length === 0)
                throw new Error("No valid rows with 'client_name' found in Excel sheet");

            return mapped;
        } catch (err) {
            throw new Error(err.message);
        }
    };

    // ── Process File ──────────────────────────────────────────────
    const processFile = async (file) => {
        if (!file) return;
        setErrors({});
        try {
            let parsedData = [];
            if (file.name.endsWith('.csv')) {
                parsedData = parseCSV(await file.text());
            } else if (file.name.endsWith('.json')) {
                const parsed = JSON.parse(await file.text());
                if (!Array.isArray(parsed)) throw new Error("JSON must be an array");
                // Validate JSON keys
                if (parsed.length > 0) {
                    const headers = Object.keys(parsed[0]).map(k => k.toLowerCase().trim());
                    validateFields(headers);
                }
                parsedData = parsed.filter(item => item.client_name);
            } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
                parsedData = parseExcel(await file.arrayBuffer());
            } else {
                throw new Error("Only CSV, JSON, or Excel files are supported");
            }
            setFileData(parsedData);
            setFileName(file.name);
            setFileSize((file.size / 1024).toFixed(1) + " KB");
            setPreview(parsedData);
        } catch (err) {
            setErrors({ file: err.message });
            setFileData(null); setFileName(""); setFileSize(""); setPreview([]);
        }
    };

    // ── Submit ────────────────────────────────────────────────────
    // const handleSubmit = async () => {
    //     if (!fileData || fileData.length === 0) return;
    //     try {
    //         setLoading(true);
    //         toast.loading("Uploading: Please wait...");

    //         const payload = fileData.map(item => ({
    //             ...item,
    //             created_by: sessionStorage.getItem('emp_code'),
    //             updated_by: sessionStorage.getItem('emp_code'),
    //             created_at: new Date().toISOString(),
    //         }));

    //         const res = await axios.post(`${BASE_URL}/mantra_projects/clientBulkCreate/`, payload);

    //         if (res.status === 200 || res.status === 201) {
    //             if (res.data?.errors && res.data.errors.length > 0) {
    //                 toast.dismiss();
    //                 res.data.errors.flatMap(errObj =>
    //                     Object.entries(errObj).flatMap(([rowIndex, fields]) =>
    //                         Object.entries(fields).flatMap(([field, messages]) =>
    //                             messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
    //                         )
    //                     )
    //                 ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
    //                 return;
    //             }
    //             await getProjectClientList();
    //             setUploadDone(true);
    //             toast.success(`Successfully uploaded ${fileData.length} project clients!`);
    //             setTimeout(handleClose, 1500);
    //         }
    //     } catch (err) {
    //         toast.dismiss();
    //         const apiErrors = err?.response?.data?.errors;
    //         if (apiErrors?.length > 0) {
    //             apiErrors.flatMap(errObj =>
    //                 Object.entries(errObj).flatMap(([rowIndex, fields]) =>
    //                     Object.entries(fields).flatMap(([field, messages]) =>
    //                         messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
    //                     )
    //                 )
    //             ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
    //         } else {
    //             handleErrorToast(err);
    //         }
    //     } finally {
    //         setLoading(false);
    //         toast.dismiss();
    //     }
    // };

    const handleSubmit = async () => {
        if (!fileData || fileData.length === 0) return;
        try {
            setLoading(true);
            toast.loading("Uploading: Please wait...");

            const payload = fileData.map(item => ({
                ...item,
                created_by: sessionStorage.getItem('emp_code'),
                updated_by: sessionStorage.getItem('emp_code'),
                created_at: new Date().toISOString(),
            }));

            const res = await axios.post(`${BASE_URL}/mantra_projects/clientBulkCreate/`, payload);

            if (res.status === 200 || res.status === 201) {
                if (res.data?.errors && res.data.errors.length > 0) {
                    toast.dismiss();
                    res.data.errors.flatMap(errObj =>
                        Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
                            if (typeof fieldOrMsg === 'string') {
                                return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
                            }
                            return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
                                [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
                            );
                        })
                    ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
                    return;
                }
                await getProjectClientList();
                setUploadDone(true);
                toast.success(`Successfully uploaded ${fileData.length} project clients!`);
                setTimeout(handleClose, 1500);
            }
        } catch (err) {
            toast.dismiss();
            const apiErrors = err?.response?.data?.errors;
            if (apiErrors?.length > 0) {
                apiErrors.flatMap(errObj =>
                    Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
                        if (typeof fieldOrMsg === 'string') {
                            return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
                        }
                        return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
                            [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
                        );
                    })
                ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
            } else {
                handleErrorToast(err);
            }
        } finally {
            setLoading(false);
            toast.dismiss();
        }
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Bulk Upload Project Clients">
                <AddwithWhiteCircle /> Bulk Upload
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-50vw">
                <Modal.Header closeButton>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                                width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                                </svg>
                            </div>
                            <div>
                                <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
                                    Bulk Upload Project Clients
                                </Modal.Title>

                            </div>
                        </div>

                        {/* Download Format Button */}
                        <button
                            onClick={handleDownloadFormat}
                            style={{
                                display: "flex", alignItems: "center", gap: 6,
                                padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 500,
                                background: "#EAF3DE", color: "#3B6D11",
                                border: "0.5px solid #97C459", cursor: "pointer",
                                marginRight: 36, transition: "all 0.15s"
                            }}
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            Download Format
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: "20px 24px" }}>

                    {/* Step 1 hint */}
                    <div style={{
                        padding: "10px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#FAEEDA", border: "0.5px solid #EF9F27",
                        fontSize: 12, color: "#854F0B", display: "flex", gap: 8, alignItems: "flex-start"
                    }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <div>
                            <strong>Step 1:</strong> Click <strong>"Download Format"</strong> (top right) to get the Excel template.
                            Fill in your data using only the allowed columns, then upload below.
                        </div>
                    </div>

                    {/* Allowed Fields Info */}
                    <div style={{
                        padding: "12px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#f7f9fc", border: "0.5px solid #d8e4f0"
                    }}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                            Allowed columns in your Excel
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                            {[
                                { field: "client_name", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "client_state", required: false, color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
                                { field: "client_ro", required: false, color: "#6B3FA0", bg: "#F0EAF8", border: "#C4A3E0" },
                            ].map(f => (
                                <span key={f.field} style={{
                                    display: "inline-flex", alignItems: "center", gap: 5,
                                    padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
                                    background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
                                }}>
                                    {f.field}
                                    {f.required && (
                                        <span style={{ fontSize: 9, background: f.color, color: "white", borderRadius: 4, padding: "1px 4px" }}>
                                            required
                                        </span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <div style={{ fontSize: 10, color: "#e05c00", marginTop: 8, fontWeight: 500 }}>
                            ⚠ Adding any column not listed above will cause an error on upload.
                        </div>
                    </div>

                    {/* Drop Zone */}
                    <div
                        onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
                        onDragLeave={() => setIsDragOver(false)}
                        onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
                        style={{
                            border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
                            borderRadius: 10, padding: "24px 20px", textAlign: "center",
                            background: isDragOver ? "#E6F1FB" : "#fafafa",
                            cursor: "pointer", position: "relative", transition: "all 0.2s"
                        }}
                    >
                        <input
                            type="file" accept=".csv,.json,.xlsx,.xls"
                            onChange={e => processFile(e.target.files[0])}
                            disabled={loading}
                            style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}
                        />
                        <div style={{
                            width: 40, height: 40, margin: "0 auto 8px",
                            background: "white", border: "0.5px solid #e0e0e0",
                            borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: "#333" }}>
                            Drop your filled Excel here or click to browse
                        </div>
                        <div style={{ fontSize: 11, color: "#aaa", marginTop: 3 }}>Step 2: Upload your filled template</div>
                    </div>

                    {/* Chosen File Chip */}
                    {fileName && (
                        <div style={{
                            marginTop: 10, display: "flex", alignItems: "center", gap: 8,
                            padding: "8px 12px", background: "white",
                            border: "0.5px solid #ddd", borderRadius: 8
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            <span style={{ flex: 1, fontSize: 12, fontWeight: 500, color: "#333" }}>{fileName}</span>
                            <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2.5">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </div>
                    )}

                    {/* Error Box */}
                    {errors.file && (
                        <div style={{
                            marginTop: 10, padding: "10px 14px",
                            background: "#FCEBEB", border: "0.5px solid #F09595",
                            borderRadius: 8, color: "#791F1F", fontSize: 12,
                            display: "flex", gap: 8, alignItems: "flex-start"
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            {errors.file}
                        </div>
                    )}

                    {/* Preview Table */}
                    {preview.length > 0 && (
                        <div style={{ marginTop: 16 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Data Preview
                                </span>
                                <span style={{
                                    fontSize: 11, padding: "2px 8px", background: "#EAF3DE",
                                    color: "#3B6D11", borderRadius: 20, fontWeight: 500
                                }}>
                                    {preview.length} item{preview.length !== 1 ? "s" : ""}
                                </span>
                            </div>
                            <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
                                <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                        <thead>
                                            <tr style={{ background: "#f7f7f7", position: "sticky", top: 0, zIndex: 1 }}>
                                                {["#", "Client Name", "State", "RO"].map(h => (
                                                    <th key={h} style={{
                                                        padding: "8px 12px", textAlign: "left",
                                                        color: "#888", fontWeight: 500,
                                                        borderBottom: "0.5px solid #e0e0e0"
                                                    }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {preview.map((row, i) => (
                                                <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
                                                    <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
                                                    <td style={{ padding: "7px 12px", fontWeight: 500, color: "#333" }}>{row.client_name}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.client_state || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.client_ro || "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Footer */}
                    <div style={{
                        borderTop: "0.5px solid #eee", display: "flex", alignItems: "center",
                        justifyContent: "space-between", padding: "12px 0 0 0", marginTop: 16
                    }}>
                        <span style={{ fontSize: 11, color: "#aaa" }}>
                            {preview.length > 0
                                ? `Ready to upload ${preview.length} project client${preview.length !== 1 ? "s" : ""}`
                                : "No file selected"}
                        </span>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                onClick={handleClose}
                                disabled={loading}
                                style={{
                                    padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
                                    border: "0.5px solid #ddd", background: "transparent", cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={loading || preview.length === 0}
                                style={{
                                    padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
                                    background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
                                    color: preview.length > 0 ? "white" : "#aaa",
                                    border: "none",
                                    cursor: preview.length > 0 && !loading ? "pointer" : "not-allowed",
                                    transition: "background 0.2s"
                                }}
                            >
                                {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload${preview.length > 0 ? ` ${preview.length} items` : ""}`}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

// const ProjectBulkUpload = ({ getProjects, SUB_COMPANIES, selectedCompany }) => {
//     const [show, setShow] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [fileData, setFileData] = useState(null);
//     const [fileName, setFileName] = useState("");
//     const [fileSize, setFileSize] = useState("");
//     const [preview, setPreview] = useState([]);
//     const [errors, setErrors] = useState({});
//     const [isDragOver, setIsDragOver] = useState(false);
//     const [uploadDone, setUploadDone] = useState(false);


//     // Reference data for format download
//     // const [refData, setRefData] = useState({
//     //     projectTypes: [],
//     //     clients: [],
//     //     departments: [],
//     // });
//     const [refData, setRefData] = useState({
//         projectTypes: [],
//         clients: [],
//         departments: [],
//         subCompanies: [],
//     });
//     const [refLoading, setRefLoading] = useState(false);

//     // const fetchReferenceData = async () => {
//     //     setRefLoading(true);
//     //     try {
//     //         const [typesRes, clientsRes, deptRes] = await Promise.all([
//     //             axios.get(`${BASE_URL}/mantra_projects/types/`),
//     //             axios.get(`${BASE_URL}/mantra_projects/clients/`),
//     //             axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/null/`),
//     //         ]);
//     //         setRefData({
//     //             projectTypes: typesRes.data || [],
//     //             clients: clientsRes.data || [],
//     //             departments: deptRes.data || [],
//     //         });
//     //     } catch (err) {
//     //         handleErrorToast(err);
//     //     } finally {
//     //         setRefLoading(false);
//     //     }
//     // };
//     const fetchReferenceData = async () => {
//         setRefLoading(true);
//         try {
//             const [typesRes, clientsRes, deptRes, subCompanyRes] = await Promise.all([
//                 axios.get(`${BASE_URL}/mantra_projects/types/`),
//                 axios.get(`${BASE_URL}/mantra_projects/clients/`),
//                 axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${selectedCompany && selectedCompany !== "null" ? selectedCompany : "null"}/active/`),
//                 // axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/null/active/`),
//                 axios.get(`${BASE_URL}/wfm/subcompanylist/null/active/`),
//             ]);
//             setRefData({
//                 projectTypes: typesRes.data || [],
//                 clients: clientsRes.data || [],
//                 departments: deptRes.data || [],
//                 subCompanies: subCompanyRes.data || [],
//             });
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setRefLoading(false);
//         }
//     };

//     const handleShow = () => {
//         setShow(true);
//         setFileData(null); setFileName(""); setFileSize("");
//         setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
//         fetchReferenceData();
//     };

//     const handleClose = () => {
//         setShow(false);
//         setFileData(null); setFileName(""); setFileSize("");
//         setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
//     };

//     // ── Download Format Excel ──────────────────────────────────────
//     const handleDownloadFormat = () => {
//         const wb = XLSX.utils.book_new();

//         // Sheet 1: Template
//         const templateHeaders = [
//             "project_code", "project_short_name", "project_full_name",
//             // "project_status",
//             "project_type", "project_client", "department",
//             "sub_company",
//             // "project_start_date", "project_end_date"
//         ];

//         const templateWS = XLSX.utils.aoa_to_sheet([templateHeaders]);

//         // Column widths
//         templateWS['!cols'] = [
//             { wch: 14 }, { wch: 20 }, { wch: 45 }, { wch: 35 }, { wch: 12 },
//             { wch: 22 }, { wch: 28 }, { wch: 18 }, { wch: 20 }, { wch: 14 }, { wch: 14 }
//         ];
//         XLSX.utils.book_append_sheet(wb, templateWS, "Project Upload Template");

//         // Sheet 2: Valid Values Reference
//         const refRows = [["Field", "Valid Values", "Notes"]];

//         // project_status
//         refRows.push(["project_status", "active, pending, completed, on_hold", "Use exactly as shown"]);

//         // project_type
//         if (refData.projectTypes.length > 0) {
//             // refRows.push([
//             //     "project_type",
//             //     refData.projectTypes.map(t => t.type_name).join(", "),
//             //     "Must match exactly"
//             // ]);
//             refRows.push(["project_type", refData.projectTypes.map(t => t.type_name).join(", "), "Must match exactly"]);
//         } else {
//             refRows.push(["project_type", "(No types found)", "Add project types first"]);
//         }

//         // project_client
//         if (refData.clients.length > 0) {
//             // refRows.push([
//             //     "project_client",
//             //     refData.clients.map(c => c.client_name).join(", "),
//             //     "Must match exactly"
//             // ]);
//             refRows.push(["project_client", refData.clients.map(c => c.client_name).join(", "), "Must match exactly"]);
//         } else {
//             refRows.push(["project_client", "(No clients found)", "Add clients first"]);
//         }

//         // department
//         if (refData.departments.length > 0) {
//             // refRows.push([
//             //     "department",
//             //     refData.departments.map(d => d.title).join(", "),
//             //     "Must match exactly"
//             // ]);
//             refRows.push(["department", refData.departments.map(d => d.title).join(", "), "Must match exactly"]);
//         } else {
//             refRows.push(["department", "(No departments found)", ""]);
//         }

//         // sub_company
//         if (SUB_COMPANIES.length > 0) {
//             // refRows.push([
//             //     "sub_company",
//             //     SUB_COMPANIES.map(s => s.title).join(", "),
//             //     "Must match exactly"
//             // ]);
//             refRows.push(["sub_company", refData.subCompanies.map(s => s.title).join(", "), "Must match exactly"]);
//         }

//         // refRows.push(["project_start_date", "YYYY-MM-DD", "e.g. 2024-01-15"]);
//         // refRows.push(["project_end_date", "YYYY-MM-DD", "e.g. 2025-06-30"]);
//         refRows.push(["project_code", "Letters, numbers, hyphens, underscores", "e.g. CSMS-001  (Required)"]);
//         refRows.push(["project_short_name", "Max 100 characters", "Required"]);
//         refRows.push(["project_full_name", "Max 500 characters", "Required"]);

//         const refWS = XLSX.utils.aoa_to_sheet(refRows);
//         refWS['!cols'] = [{ wch: 22 }, { wch: 80 }, { wch: 30 }];
//         XLSX.utils.book_append_sheet(wb, refWS, "Valid Values Reference");

//         // Sheet 3: Detailed list sheets for long dropdowns
//         const appendListSheet = (sheetName, title, items) => {
//             if (!items.length) return;
//             const rows = [[title], ...items.map(v => [v])];
//             const ws = XLSX.utils.aoa_to_sheet(rows);
//             ws['!cols'] = [{ wch: 40 }];
//             XLSX.utils.book_append_sheet(wb, ws, sheetName);
//         };

//         // appendListSheet("Project Types", "project_type (use exact name)", refData.projectTypes.map(t => t.type_name));
//         // appendListSheet("Clients", "project_client (use exact name)", refData.clients.map(c => c.client_name));
//         // appendListSheet("Departments", "department (use exact name)", refData.departments.map(d => d.title));
//         // appendListSheet("Sub Companies", "sub_company (use exact name)", SUB_COMPANIES.map(s => s.title));

//         appendListSheet("Project Types", "project_type (use exact name)", refData.projectTypes.map(t => t.type_name));
//         appendListSheet("Clients", "project_client (use exact name)", refData.clients.map(c => c.client_name));
//         appendListSheet("Departments", "department (use exact name)", refData.departments.map(d => d.title));
//         appendListSheet("Sub Companies", "sub_company (use exact name)", refData.subCompanies.map(s => s.title));

//         XLSX.writeFile(wb, `Project_Bulk_Upload_Format_${new Date().toISOString().split("T")[0]}.xlsx`);
//         toast.success("Format downloaded successfully!");
//     };

//     // ── Parse Helpers ─────────────────────────────────────────────
//     const parseCSV = (csvText) => {
//         const lines = csvText.trim().split('\n');
//         if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");
//         const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
//         ['project_code', 'project_short_name', 'project_full_name'].forEach(f => {
//             if (!headers.includes(f)) throw new Error(`CSV must contain '${f}' column`);
//         });
//         const idx = (name) => headers.indexOf(name);
//         const data = [];
//         for (let i = 1; i < lines.length; i++) {
//             if (lines[i].trim() === '') continue;
//             const v = lines[i].split(',').map(v => v.trim());
//             const item = {
//                 project_code: v[idx('project_code')] || "",
//                 project_short_name: v[idx('project_short_name')] || "",
//                 project_full_name: v[idx('project_full_name')] || "",
//                 // project_description: v[idx('project_description')] || "",
//                 // project_status: v[idx('project_status')] || "",
//                 project_type: v[idx('project_type')] || "",
//                 project_client: v[idx('project_client')] || "",
//                 department: v[idx('department')] || "",
//                 sub_company: v[idx('sub_company')] || "",
//                 // project_start_date: v[idx('project_start_date')] || null,
//                 // project_end_date: v[idx('project_end_date')] || null,
//             };
//             if (item.project_code) data.push(item);
//         }
//         return data;
//     };

//     const parseExcel = (arrayBuffer) => {
//         try {
//             const workbook = XLSX.read(arrayBuffer, { type: 'array' });
//             const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//             const data = XLSX.utils.sheet_to_json(worksheet);
//             if (!Array.isArray(data) || data.length === 0)
//                 throw new Error("Excel sheet is empty or invalid");
//             const mapped = data.map(row => {
//                 const lk = Object.keys(row).reduce((acc, k) => {
//                     acc[k.toLowerCase().replace(/\s+/g, '_')] = row[k];
//                     return acc;
//                 }, {});
//                 return {
//                     project_code: String(lk['project_code'] || ""),
//                     project_short_name: String(lk['project_short_name'] || lk['short_name'] || ""),
//                     project_full_name: String(lk['project_full_name'] || lk['full_name'] || ""),
//                     // project_description: String(lk['project_description'] || lk['description'] || ""),
//                     // project_status: String(lk['project_status'] || lk['status'] || ""),
//                     project_type: String(lk['project_type'] || lk['type'] || ""),
//                     project_client: String(lk['project_client'] || lk['client'] || ""),
//                     department: String(lk['department'] || ""),
//                     sub_company: String(lk['sub_company'] || ""),
//                     // project_start_date: lk['project_start_date'] || null,
//                     // project_end_date: lk['project_end_date'] || null,
//                 };
//             }).filter(item => item.project_code);
//             if (mapped.length === 0)
//                 throw new Error("No valid rows with 'project_code' found");
//             return mapped;
//         } catch (err) {
//             throw new Error(`Failed to parse Excel file: ${err.message}`);
//         }
//     };

//     const processFile = async (file) => {
//         if (!file) return;
//         setErrors({});
//         try {
//             let parsedData = [];
//             if (file.name.endsWith('.csv')) {
//                 parsedData = parseCSV(await file.text());
//             } else if (file.name.endsWith('.json')) {
//                 parsedData = JSON.parse(await file.text());
//                 if (!Array.isArray(parsedData)) throw new Error("JSON must be an array");
//             } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
//                 parsedData = parseExcel(await file.arrayBuffer());
//             } else {
//                 throw new Error("Only  Excel files are supported");
//             }
//             setFileData(parsedData);
//             setFileName(file.name);
//             setFileSize((file.size / 1024).toFixed(1) + " KB");
//             setPreview(parsedData);
//         } catch (err) {
//             setErrors({ file: err.message });
//             setFileData(null); setFileName(""); setFileSize(""); setPreview([]);
//         }
//     };
//     console.log(fileData, 'filedata')
//     // ── Submit ────────────────────────────────────────────────────
//     const handleSubmit = async () => {
//         if (!fileData || fileData.length === 0) return;
//         try {
//             setLoading(true);
//             toast.loading("Uploading: Please wait...");
//             const payload = fileData.map(item => ({
//                 ...item,
//                 created_by: sessionStorage.getItem('emp_code'),
//                 updated_by: sessionStorage.getItem('emp_code'),
//                 created_at: new Date().toISOString(),
//             }));
//             console.log(payload, 'payload ddd>>>>')
//             const res = await axios.post(`${BASE_URL}/mantra_projects/projectsBulkCreate/`, payload);
//             if (res.status === 200 || res.status === 201) {
//                 if (res.data?.errors && res.data.errors.length > 0) {
//                     toast.dismiss();
//                     res.data.errors.flatMap(errObj =>
//                         Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                             Object.entries(fields).flatMap(([field, messages]) =>
//                                 messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                             )
//                         )
//                     ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
//                     return;
//                 }
//                 await getProjects();
//                 setUploadDone(true);
//                 toast.success(`Successfully uploaded ${fileData.length} projects!`);
//                 setTimeout(handleClose, 1500);
//             }
//         } catch (err) {
//             toast.dismiss();
//             const apiErrors = err?.response?.data?.errors;
//             if (apiErrors?.length > 0) {
//                 apiErrors.flatMap(errObj =>
//                     Object.entries(errObj).flatMap(([rowIndex, fields]) =>
//                         Object.entries(fields).flatMap(([field, messages]) =>
//                             messages.map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
//                         )
//                     )
//                 ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
//             } else {
//                 handleErrorToast(err);
//             }
//         } finally {
//             setLoading(false);
//             toast.dismiss();
//         }
//     };



//     const ReferenceChips = ({ label, items, color, bg, border }) => {
//         const [showAll, setShowAll] = useState(false);

//         if (!items || items.length === 0) return null;

//         const visibleItems = showAll ? items : items.slice(0, 6);

//         return (
//             <div style={{ marginBottom: 8 }}>
//                 <span style={{
//                     fontSize: 11,
//                     fontWeight: 600,
//                     color: "#555",
//                     marginRight: 6
//                 }}>
//                     {label}:
//                 </span>

//                 {visibleItems.map((v, i) => (
//                     <span
//                         key={i}
//                         style={{
//                             display: "inline-block",
//                             margin: "2px 3px",
//                             padding: "2px 8px",
//                             borderRadius: 20,
//                             fontSize: 10,
//                             fontWeight: 500,
//                             background: bg,
//                             color,
//                             border: `0.5px solid ${border}`,
//                             cursor: "pointer"
//                         }}
//                     >
//                         {v}
//                     </span>
//                 ))}

//                 {items.length > 6 && (
//                     <span
//                         onClick={() => setShowAll(!showAll)}
//                         style={{
//                             fontSize: 10,
//                             color: "#007bff",
//                             cursor: "pointer",
//                             marginLeft: 5
//                         }}
//                     >
//                         {showAll
//                             ? "Show less"
//                             : `+${items.length - 6} more`}
//                     </span>
//                 )}
//             </div>
//         );
//     };

//     return (
//         <>
//             <button className="upload-svg" onClick={handleShow} title="Bulk Upload Projects">
//                 <AddwithWhiteCircle /> Bulk Upload
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-60vw">
//                 <Modal.Header closeButton>
//                     <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                             <div style={{
//                                 width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
//                                 display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
//                             }}>
//                                 <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                     <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                                 </svg>
//                             </div>
//                             <div>
//                                 <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
//                                     Bulk Upload Projects
//                                 </Modal.Title>

//                             </div>
//                         </div>

//                         {/* Download Format Button */}
//                         <button
//                             onClick={handleDownloadFormat}
//                             disabled={refLoading}
//                             style={{
//                                 display: "flex", alignItems: "center", gap: 6,
//                                 padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 500,
//                                 background: "#EAF3DE", color: "#3B6D11",
//                                 border: "0.5px solid #97C459", cursor: "pointer",
//                                 marginRight: 36, transition: "all 0.15s"
//                             }}
//                         >
//                             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
//                             </svg>
//                             {refLoading ? "Loading..." : "Download Format"}
//                         </button>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body style={{ padding: "20px 24px" }}>

//                     {/* Step 1 — Download format hint */}
//                     <div style={{
//                         padding: "10px 14px", borderRadius: 8, marginBottom: 16,
//                         background: "#FAEEDA", border: "0.5px solid #EF9F27",
//                         fontSize: 12, color: "#854F0B", display: "flex", gap: 8, alignItems: "flex-start"
//                     }}>
//                         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
//                             <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
//                         </svg>
//                         <div>
//                             <strong>Step 1:</strong> Click <strong>"Download Format"</strong> (top right) to get the Excel template with all fields and valid reference values.
//                             &nbsp;Then fill in your data and upload below.
//                         </div>
//                     </div>

//                     {/* Format Badges */}
//                     <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
//                         {[
//                             { label: "Excel .xlsx", color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },

//                         ].map(f => (
//                             <span key={f.label} style={{
//                                 padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
//                                 background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
//                             }}>{f.label}</span>
//                         ))}
//                         <span style={{ fontSize: 11, color: "#aaa" }}>
//                             Required: project_code, project_short_name, project_full_name
//                         </span>
//                     </div>

//                     {/* Reference Values Panel */}
//                     {!refLoading && (
//                         <div style={{
//                             padding: "12px 14px", borderRadius: 8, marginBottom: 16,
//                             background: "#f7f9fc", border: "0.5px solid #d8e4f0"
//                         }}>
//                             <div style={{ fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                                 Valid values for dropdown fields
//                             </div>
//                             <ReferenceChips
//                                 label="Project Type"
//                                 items={refData.projectTypes.map(t => t.type_name)}
//                                 color="#3B6D11" bg="#EAF3DE" border="#97C459"
//                             />
//                             <ReferenceChips
//                                 label="Client"
//                                 items={refData.clients.map(c => c.client_name)}
//                                 color="#185FA5" bg="#E6F1FB" border="#85B7EB"
//                             />
//                             <ReferenceChips
//                                 label="Department"
//                                 items={refData.departments.map(d => d.title)}
//                                 color="#6B3FA0" bg="#F0EAF8" border="#C4A3E0"
//                             />
//                             {/* <ReferenceChips
//                                 label="Sub Company"
//                                 items={SUB_COMPANIES.map(s => s.title)}
//                                 color="#854F0B" bg="#FAEEDA" border="#EF9F27"
//                             /> */}
//                             <ReferenceChips
//                                 label="Sub Company"
//                                 items={refData.subCompanies.map(s => s.title)}
//                                 color="#854F0B" bg="#FAEEDA" border="#EF9F27"
//                             />
//                             <div style={{ fontSize: 10, color: "#aaa", marginTop: 4 }}>
//                                 Use these exact names in your Excel. Full list available in the downloaded format file.
//                             </div>
//                         </div>
//                     )}
//                     {refLoading && (
//                         <div style={{ padding: "10px 14px", borderRadius: 8, marginBottom: 16, background: "#f7f9fc", border: "0.5px solid #d8e4f0", fontSize: 12, color: "#aaa" }}>
//                             Loading valid values...
//                         </div>
//                     )}

//                     {/* Drop Zone */}
//                     <div
//                         onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
//                         onDragLeave={() => setIsDragOver(false)}
//                         onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
//                         style={{
//                             border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
//                             borderRadius: 10, padding: "24px 20px", textAlign: "center",
//                             background: isDragOver ? "#E6F1FB" : "#fafafa",
//                             cursor: "pointer", position: "relative", transition: "all 0.2s"
//                         }}
//                     >
//                         <input
//                             type="file" accept=".xlsx,.xls"
//                             onChange={e => processFile(e.target.files[0])}
//                             disabled={loading}
//                             style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}
//                         />
//                         <div style={{
//                             width: 40, height: 40, margin: "0 auto 8px",
//                             background: "white", border: "0.5px solid #e0e0e0",
//                             borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center"
//                         }}>
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
//                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//                                 <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
//                             </svg>
//                         </div>
//                         <div style={{ fontSize: 13, fontWeight: 500, color: "#333" }}>
//                             Drop your filled Excel here or click to browse
//                         </div>
//                         <div style={{ fontSize: 11, color: "#aaa", marginTop: 3 }}>Step 2: Upload your filled template</div>
//                     </div>

//                     {/* Chosen File Chip */}
//                     {fileName && (
//                         <div style={{
//                             marginTop: 10, display: "flex", alignItems: "center", gap: 8,
//                             padding: "8px 12px", background: "white",
//                             border: "0.5px solid #ddd", borderRadius: 8
//                         }}>
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2">
//                                 <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//                                 <polyline points="14 2 14 8 20 8" />
//                             </svg>
//                             <span style={{ flex: 1, fontSize: 12, fontWeight: 500, color: "#333" }}>{fileName}</span>
//                             <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
//                             <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2.5">
//                                 <polyline points="20 6 9 17 4 12" />
//                             </svg>
//                         </div>
//                     )}

//                     {/* Error Box */}
//                     {errors.file && (
//                         <div style={{
//                             marginTop: 10, padding: "10px 14px",
//                             background: "#FCEBEB", border: "0.5px solid #F09595",
//                             borderRadius: 8, color: "#791F1F", fontSize: 12
//                         }}>
//                             {errors.file}
//                         </div>
//                     )}

//                     {/* Preview Table */}
//                     {preview.length > 0 && (
//                         <div style={{ marginTop: 16 }}>
//                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
//                                 <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
//                                     Data Preview
//                                 </span>
//                                 <span style={{
//                                     fontSize: 11, padding: "2px 8px", background: "#EAF3DE",
//                                     color: "#3B6D11", borderRadius: 20, fontWeight: 500
//                                 }}>
//                                     {preview.length} item{preview.length !== 1 ? "s" : ""}
//                                 </span>
//                             </div>
//                             <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
//                                 <div style={{ maxHeight: "260px", overflowY: "auto" }}>
//                                     <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
//                                         <thead>
//                                             <tr style={{ background: "#f7f7f7", position: "sticky", top: 0, zIndex: 1 }}>
//                                                 {["#", "Code", "Short Name", "Full Name", "Type", "Sub Company", "Client", "Department"].map(h => (
//                                                     <th key={h} style={{
//                                                         padding: "8px 12px", textAlign: "left",
//                                                         color: "#888", fontWeight: 500,
//                                                         borderBottom: "0.5px solid #e0e0e0", whiteSpace: "nowrap"
//                                                     }}>{h}</th>
//                                                 ))}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {preview.map((row, i) => (
//                                                 <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
//                                                     <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
//                                                     <td style={{ padding: "7px 12px", fontWeight: 500, color: "#333", whiteSpace: "nowrap" }}>{row.project_code || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#333" }}>{row.project_short_name || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.project_full_name || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666" }}>{row.project_type || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666" }}>{row.sub_company || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666" }}>{row.project_client || "—"}</td>
//                                                     <td style={{ padding: "7px 12px", color: "#666" }}>{row.department || "—"}</td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {/* Footer */}
//                     <div style={{
//                         borderTop: "0.5px solid #eee", display: "flex", alignItems: "center",
//                         justifyContent: "space-between", padding: "12px 0 0 0", marginTop: 16
//                     }}>
//                         <span style={{ fontSize: 11, color: "#aaa" }}>
//                             {preview.length > 0
//                                 ? `Ready to upload ${preview.length} project${preview.length !== 1 ? "s" : ""}`
//                                 : "No file selected"}
//                         </span>
//                         <div style={{ display: "flex", gap: 8 }}>
//                             <button
//                                 onClick={handleClose}
//                                 disabled={loading}
//                                 style={{
//                                     padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                     border: "0.5px solid #ddd", background: "transparent", cursor: "pointer"
//                                 }}
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleSubmit}
//                                 disabled={loading || preview.length === 0}
//                                 style={{
//                                     padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
//                                     background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
//                                     color: preview.length > 0 ? "white" : "#aaa",
//                                     border: "none",
//                                     cursor: preview.length > 0 && !loading ? "pointer" : "not-allowed",
//                                     transition: "background 0.2s"
//                                 }}
//                             >
//                                 {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload${preview.length > 0 ? ` ${preview.length} items` : ""}`}
//                             </button>
//                         </div>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const ProjectBulkUpload = ({ getProjects, SUB_COMPANIES, selectedCompany }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState("");
    const [preview, setPreview] = useState([]);
    const [errors, setErrors] = useState({});
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadDone, setUploadDone] = useState(false);

    const subCompanyId = sessionStorage.getItem("company_id");

    const [refData, setRefData] = useState({
        projectTypes: [],
        clients: [],
        departments: [],
    });
    const [refLoading, setRefLoading] = useState(false);

    const fetchReferenceData = async () => {
        setRefLoading(true);
        try {
            const [typesRes, clientsRes, deptRes] = await Promise.all([
                axios.get(`${BASE_URL}/mantra_projects/types/`),
                axios.get(`${BASE_URL}/mantra_projects/clientsearch/`),
                axios.get(
                    `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${subCompanyId || "null"}/active/`
                ),
            ]);
            setRefData({
                projectTypes: typesRes.data || [],
                clients: clientsRes.data.results || [],
                clients: clientsRes.data.results || [],
                departments: deptRes.data || [],
            });
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setRefLoading(false);
        }
    };

    const handleShow = () => {
        setShow(true);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
        fetchReferenceData();
    };

    const handleClose = () => {
        setShow(false);
        setFileData(null); setFileName(""); setFileSize("");
        setPreview([]); setErrors({}); setIsDragOver(false); setUploadDone(false);
    };

    // ── Download Format Excel ─────────────────────────────────────
    const handleDownloadFormat = () => {
        const wb = XLSX.utils.book_new();

        // Sheet 1: Template — no sub_company column
        const templateHeaders = [
            "project_code", "project_short_name", "project_full_name",
            "project_type", "project_client", "department",
        ];
        const templateWS = XLSX.utils.aoa_to_sheet([templateHeaders]);
        templateWS['!cols'] = [
            { wch: 14 }, { wch: 20 }, { wch: 45 },
            { wch: 35 }, { wch: 28 }, { wch: 22 },
        ];
        XLSX.utils.book_append_sheet(wb, templateWS, "Project Upload Template");

        // Sheet 2: Valid Values Reference
        const refRows = [["Field", "Valid Values", "Notes"]];

        if (refData.projectTypes.length > 0) {
            refRows.push(["project_type", refData.projectTypes.map(t => t.type_name).join(", "), "Must match exactly"]);
        } else {
            refRows.push(["project_type", "(No types found)", "Add project types first"]);
        }

        if (refData.clients.length > 0) {
            refRows.push(["project_client", refData.clients.map(c => c.client_name).join(", "), "Must match exactly"]);
        } else {
            refRows.push(["project_client", "(No clients found)", "Add clients first"]);
        }

        if (refData.departments.length > 0) {
            refRows.push(["department", refData.departments.map(d => d.title).join(", "), "Optional — must match exactly if provided"]);
        } else {
            refRows.push(["department", "(No departments found)", ""]);
        }

        refRows.push(["project_code", "Letters, numbers, hyphens, underscores, slashes — MUST be unique", "e.g. CSMS-001  (Required)"]);
        refRows.push(["project_short_name", "Max 100 characters", "Required"]);
        refRows.push(["project_full_name", "Max 500 characters", "Optional"]);

        const refWS = XLSX.utils.aoa_to_sheet(refRows);
        refWS['!cols'] = [{ wch: 22 }, { wch: 80 }, { wch: 35 }];
        XLSX.utils.book_append_sheet(wb, refWS, "Valid Values Reference");

        // Sheet 3: Detail list sheets
        const appendListSheet = (sheetName, title, items) => {
            if (!items.length) return;
            const rows = [[title], ...items.map(v => [v])];
            const ws = XLSX.utils.aoa_to_sheet(rows);
            ws['!cols'] = [{ wch: 40 }];
            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        };

        appendListSheet("Project Types", "project_type (use exact name)", refData.projectTypes.map(t => t.type_name));
        appendListSheet("Clients", "project_client (use exact name)", refData.clients.map(c => c.client_name));
        appendListSheet("Departments", "department (use exact name)", refData.departments.map(d => d.title));

        XLSX.writeFile(wb, `Project_Bulk_Upload_Format_${new Date().toISOString().split("T")[0]}.xlsx`);
        toast.success("Format downloaded successfully!");
    };

    // ── Parsers ───────────────────────────────────────────────────
    const parseCSV = (csvText) => {
        const lines = csvText.trim().split('\n');
        if (lines.length < 2) throw new Error("CSV must have headers and at least one data row");
        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
        ['project_code', 'project_short_name'].forEach(f => {
            if (!headers.includes(f)) throw new Error(`CSV must contain '${f}' column`);
        });
        const idx = (name) => headers.indexOf(name);
        const data = [];
        for (let i = 1; i < lines.length; i++) {
            if (lines[i].trim() === '') continue;
            const v = lines[i].split(',').map(v => v.trim());
            const item = {
                project_code: v[idx('project_code')] || "",
                project_short_name: v[idx('project_short_name')] || "",
                project_full_name: idx('project_full_name') !== -1 ? v[idx('project_full_name')] || "" : "",
                project_type: idx('project_type') !== -1 ? v[idx('project_type')] || "" : "",
                project_client: idx('project_client') !== -1 ? v[idx('project_client')] || "" : "",
                department: idx('department') !== -1 ? v[idx('department')] || "" : "",
            };
            if (item.project_code) data.push(item);
        }
        return data;
    };

    const parseExcel = (arrayBuffer) => {
        try {
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(worksheet);
            if (!Array.isArray(data) || data.length === 0)
                throw new Error("Excel sheet is empty or invalid");
            const mapped = data.map(row => {
                const lk = Object.keys(row).reduce((acc, k) => {
                    acc[k.toLowerCase().replace(/\s+/g, '_')] = row[k];
                    return acc;
                }, {});
                return {
                    project_code: String(lk['project_code'] || ""),
                    project_short_name: String(lk['project_short_name'] || lk['short_name'] || ""),
                    project_full_name: String(lk['project_full_name'] || lk['full_name'] || ""),
                    project_type: String(lk['project_type'] || lk['type'] || ""),
                    project_client: String(lk['project_client'] || lk['client'] || ""),
                    department: String(lk['department'] || ""),
                };
            }).filter(item => item.project_code);
            if (mapped.length === 0)
                throw new Error("No valid rows with 'project_code' found");
            return mapped;
        } catch (err) {
            throw new Error(`Failed to parse Excel file: ${err.message}`);
        }
    };

    const processFile = async (file) => {
        if (!file) return;
        setErrors({});
        try {
            let parsedData = [];
            if (file.name.endsWith('.csv')) {
                parsedData = parseCSV(await file.text());
            } else if (file.name.endsWith('.json')) {
                parsedData = JSON.parse(await file.text());
                if (!Array.isArray(parsedData)) throw new Error("JSON must be an array");
            } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
                parsedData = parseExcel(await file.arrayBuffer());
            } else {
                throw new Error("Only Excel files are supported");
            }

            // Client-side duplicate project_code check
            const codes = parsedData.map(r => r.project_code).filter(Boolean);
            const duplicates = codes.filter((c, idx) => codes.indexOf(c) !== idx);
            if (duplicates.length > 0) {
                throw new Error(
                    `Duplicate project_code(s) found in file: ${[...new Set(duplicates)].join(", ")}. Each project_code must be unique.`
                );
            }

            setFileData(parsedData);
            setFileName(file.name);
            setFileSize((file.size / 1024).toFixed(1) + " KB");
            setPreview(parsedData);
        } catch (err) {
            setErrors({ file: err.message });
            setFileData(null); setFileName(""); setFileSize(""); setPreview([]);
        }
    };

    // ── Submit ────────────────────────────────────────────────────
    const handleSubmit = async () => {
        if (!fileData || fileData.length === 0) return;
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            setLoading(true);
            // toast.loading("Uploading: Please wait...");
            const payload = fileData.map(item => ({
                ...item,
                sub_company: subCompanyId,          // always from sessionStorage
                created_by: sessionStorage.getItem('emp_code'),
                updated_by: sessionStorage.getItem('emp_code'),
                created_at: new Date().toISOString(),
            }));
            const res = await axios.post(`${BASE_URL}/mantra_projects/projectsBulkCreate/`, payload);
            if (res.status === 200 || res.status === 201) {
                // if (res.data?.errors && res.data.errors.length > 0) {
                //     toast.dismiss();
                //     res.data.errors.flatMap(errObj =>
                //         Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
                //             if (typeof fieldOrMsg === 'string') {
                //                 return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
                //             }
                //             return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
                //                 [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
                //             );
                //         })
                //     ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
                //     return;
                // }
                await getProjects();
                setUploadDone(true);
                // handleClose(false);
                toast.success(`Successfully uploaded ${fileData.length} projects!`);
                setTimeout(handleClose, 1500);
            } else {
                alert(res);
            }
        }
        // catch (err) {
        //     toast.dismiss();
        //     const apiErrors = err?.response?.data?.errors;
        //     if (apiErrors?.length > 0) {
        //         apiErrors.flatMap(errObj =>
        //             Object.entries(errObj).flatMap(([rowIndex, fieldOrMsg]) => {
        //                 if (typeof fieldOrMsg === 'string') {
        //                     return [`Row ${parseInt(rowIndex) + 1}: ${fieldOrMsg}`];
        //                 }
        //                 return Object.entries(fieldOrMsg).flatMap(([field, messages]) =>
        //                     [].concat(messages).map(msg => `Row ${parseInt(rowIndex) + 1}: ${msg}`)
        //                 );
        //             })
        //         ).forEach((msg, i) => setTimeout(() => toast.error(msg, { autoClose: 5000 }), i * 150));
        //     } else {
        //         handleErrorToast(err);
        //     }
        // } 
        catch (err) {
            handleCustomErrorToast(err, loadingToastId);
        }
        finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const ReferenceChips = ({ label, items, color, bg, border }) => {
        const [showAll, setShowAll] = useState(false);
        if (!items || items.length === 0) return null;
        const visibleItems = showAll ? items : items.slice(0, 6);
        return (
            <div style={{ marginBottom: 8 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: "#555", marginRight: 6 }}>{label}:</span>
                {visibleItems.map((v, i) => (
                    <span key={i} style={{
                        display: "inline-block", margin: "2px 3px", padding: "2px 8px",
                        borderRadius: 20, fontSize: 10, fontWeight: 500,
                        background: bg, color, border: `0.5px solid ${border}`,
                    }}>{v}</span>
                ))}
                {items.length > 6 && (
                    <span onClick={() => setShowAll(!showAll)} style={{ fontSize: 10, color: "#007bff", cursor: "pointer", marginLeft: 5 }}>
                        {showAll ? "Show less" : `+${items.length - 6} more`}
                    </span>
                )}
            </div>
        );
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Bulk Upload Projects">
                <AddwithWhiteCircle /> Bulk Upload
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-60vw">
                <Modal.Header closeButton>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{
                                width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
                                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                            }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                                </svg>
                            </div>
                            <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
                                Bulk Upload Projects
                            </Modal.Title>
                        </div>
                        <button
                            onClick={handleDownloadFormat}
                            disabled={refLoading}
                            style={{
                                display: "flex", alignItems: "center", gap: 6,
                                padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 500,
                                background: "#EAF3DE", color: "#3B6D11",
                                border: "0.5px solid #97C459", cursor: "pointer",
                                marginRight: 36, transition: "all 0.15s"
                            }}
                        >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                            {refLoading ? "Loading..." : "Download Format"}
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: "20px 24px" }}>

                    {/* Step 1 hint */}
                    <div style={{
                        padding: "10px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#FAEEDA", border: "0.5px solid #EF9F27",
                        fontSize: 12, color: "#854F0B", display: "flex", gap: 8, alignItems: "flex-start"
                    }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                            <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                        </svg>
                        <div>
                            <strong>Step 1:</strong> Click <strong>"Download Format"</strong> (top right) to get the Excel template with valid reference values. Fill in your data and upload below.
                        </div>
                    </div>

                    {/* Format badge + required note */}
                    {/* <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500, background: "#EAF3DE", color: "#3B6D11", border: "0.5px solid #97C459" }}>
                            Excel .xlsx
                        </span>
                        <span style={{ fontSize: 11, color: "#aaa" }}>
                            Required: <strong>project_code</strong> (unique), <strong>project_short_name</strong> &nbsp;·&nbsp; Optional: project_full_name, department
                        </span>
                    </div> */}

                    {/* Reference Values Panel */}
                    {/* {!refLoading ? (
                        <div style={{
                            padding: "12px 14px", borderRadius: 8, marginBottom: 16,
                            background: "#f7f9fc", border: "0.5px solid #d8e4f0"
                        }}>
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Valid values for dropdown fields
                            </div>
                            <ReferenceChips label="Project Type" items={refData.projectTypes.map(t => t.type_name)} color="#3B6D11" bg="#EAF3DE" border="#97C459" />
                            <ReferenceChips label="Client" items={refData.clients.map(c => c.client_name)} color="#185FA5" bg="#E6F1FB" border="#85B7EB" />
                            <ReferenceChips label="Department" items={refData.departments.map(d => d.title)} color="#6B3FA0" bg="#F0EAF8" border="#C4A3E0" />
                            <div style={{ fontSize: 10, color: "#aaa", marginTop: 4 }}>
                                Use these exact names in your Excel. Full list available in the downloaded format file.
                            </div>
                        </div>
                    ) : (
                        <div style={{ padding: "10px 14px", borderRadius: 8, marginBottom: 16, background: "#f7f9fc", border: "0.5px solid #d8e4f0", fontSize: 12, color: "#aaa" }}>
                            Loading valid values...
                        </div>
                    )} */}

                    {/* Allowed Columns Info */}
                    <div style={{
                        padding: "12px 14px", borderRadius: 8, marginBottom: 16,
                        background: "#f7f9fc", border: "0.5px solid #d8e4f0"
                    }}>
                        <div style={{ fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                            Allowed columns in your Excel
                        </div>
                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                            {[
                                { field: "project_code", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "project_short_name", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "project_full_name", required: false, color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
                                { field: "project_type", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "project_client", required: true, color: "#3B6D11", bg: "#EAF3DE", border: "#97C459" },
                                { field: "department", required: false, color: "#185FA5", bg: "#E6F1FB", border: "#85B7EB" },
                            ].map(f => (
                                <span key={f.field} style={{
                                    display: "inline-flex", alignItems: "center", gap: 5,
                                    padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 500,
                                    background: f.bg, color: f.color, border: `0.5px solid ${f.border}`
                                }}>
                                    {f.field}
                                    {f.required && (
                                        <span style={{
                                            fontSize: 9, background: f.color, color: "white",
                                            borderRadius: 4, padding: "1px 4px"
                                        }}>
                                            required
                                        </span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <div style={{ fontSize: 10, color: "#e05c00", marginTop: 8, fontWeight: 500 }}>
                            ⚠ Adding any column not listed above will cause an error on upload.
                        </div>
                    </div>

                    {/* Drop Zone */}
                    <div
                        onDragOver={e => { e.preventDefault(); setIsDragOver(true); }}
                        onDragLeave={() => setIsDragOver(false)}
                        onDrop={e => { e.preventDefault(); setIsDragOver(false); processFile(e.dataTransfer.files[0]); }}
                        style={{
                            border: `1.5px dashed ${isDragOver ? "#378ADD" : "#ccc"}`,
                            borderRadius: 10, padding: "24px 20px", textAlign: "center",
                            background: isDragOver ? "#E6F1FB" : "#fafafa",
                            cursor: "pointer", position: "relative", transition: "all 0.2s"
                        }}
                    >
                        <input
                            type="file" accept=".xlsx,.xls"
                            onChange={e => processFile(e.target.files[0])}
                            disabled={loading}
                            style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer", width: "100%", height: "100%" }}
                        />
                        <div style={{
                            width: 40, height: 40, margin: "0 auto 8px", background: "white",
                            border: "0.5px solid #e0e0e0", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#378ADD" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                            </svg>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 500, color: "#333" }}>
                            Drop your filled Excel here or click to browse
                        </div>
                        <div style={{ fontSize: 11, color: "#aaa", marginTop: 3 }}>Step 2: Upload your filled template</div>
                    </div>

                    {/* Chosen File Chip */}
                    {fileName && (
                        <div style={{
                            marginTop: 10, display: "flex", alignItems: "center", gap: 8,
                            padding: "8px 12px", background: "white", border: "0.5px solid #ddd", borderRadius: 8
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                            </svg>
                            <span style={{ flex: 1, fontSize: 12, fontWeight: 500, color: "#333" }}>{fileName}</span>
                            <span style={{ fontSize: 11, color: "#888" }}>{fileSize}</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2.5">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </div>
                    )}

                    {/* Error Box */}
                    {errors.file && (
                        <div style={{
                            marginTop: 10, padding: "10px 14px",
                            background: "#FCEBEB", border: "0.5px solid #F09595",
                            borderRadius: 8, color: "#791F1F", fontSize: 12,
                            display: "flex", gap: 8, alignItems: "flex-start"
                        }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0, marginTop: 1 }}>
                                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            {errors.file}
                        </div>
                    )}

                    {/* Preview Table — no Sub Company column */}
                    {preview.length > 0 && (
                        <div style={{ marginTop: 16 }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                                <span style={{ fontSize: 11, fontWeight: 500, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                    Data Preview
                                </span>
                                <span style={{ fontSize: 11, padding: "2px 8px", background: "#EAF3DE", color: "#3B6D11", borderRadius: 20, fontWeight: 500 }}>
                                    {preview.length} item{preview.length !== 1 ? "s" : ""}
                                </span>
                            </div>
                            <div style={{ border: "0.5px solid #e0e0e0", borderRadius: 8, overflow: "hidden" }}>
                                <div style={{ maxHeight: "260px", overflowY: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                                        <thead>
                                            <tr style={{ background: "#f7f7f7", position: "sticky", top: 0, zIndex: 1 }}>
                                                {["#", "Code", "Short Name", "Full Name", "Type", "Client", "Department"].map(h => (
                                                    <th key={h} style={{
                                                        padding: "8px 12px", textAlign: "left",
                                                        color: "#888", fontWeight: 500,
                                                        borderBottom: "0.5px solid #e0e0e0", whiteSpace: "nowrap"
                                                    }}>{h}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {preview.map((row, i) => (
                                                <tr key={i} style={{ borderBottom: "0.5px solid #f0f0f0" }}>
                                                    <td style={{ padding: "7px 12px", color: "#bbb" }}>{i + 1}</td>
                                                    <td style={{ padding: "7px 12px", fontWeight: 500, color: "#333", whiteSpace: "nowrap" }}>{row.project_code || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#333" }}>{row.project_short_name || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666", maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row.project_full_name || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.project_type || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.project_client || "—"}</td>
                                                    <td style={{ padding: "7px 12px", color: "#666" }}>{row.department || "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Footer */}
                    <div style={{
                        borderTop: "0.5px solid #eee", display: "flex", alignItems: "center",
                        justifyContent: "space-between", padding: "12px 0 0 0", marginTop: 16
                    }}>
                        <span style={{ fontSize: 11, color: "#aaa" }}>
                            {preview.length > 0 ? `Ready to upload ${preview.length} project${preview.length !== 1 ? "s" : ""}` : "No file selected"}
                        </span>
                        <div style={{ display: "flex", gap: 8 }}>
                            <button
                                onClick={handleClose}
                                disabled={loading}
                                style={{ padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500, border: "0.5px solid #ddd", background: "transparent", cursor: "pointer" }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmit}
                                disabled={loading || preview.length === 0}
                                style={{
                                    padding: "7px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
                                    background: uploadDone ? "#3B6D11" : preview.length > 0 ? "#185FA5" : "#e0e0e0",
                                    color: preview.length > 0 ? "white" : "#aaa",
                                    border: "none",
                                    cursor: preview.length > 0 && !loading ? "pointer" : "not-allowed",
                                    transition: "background 0.2s"
                                }}
                            >
                                {loading ? "Uploading..." : uploadDone ? "✓ Uploaded!" : `Upload${preview.length > 0 ? ` ${preview.length} items` : ""}`}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export { ProjectAdd, ProjectUpdate, ProjectDelete, ProjectTypeAdd, ProjectTypeUpdate, ProjectTypeDelete, ProjectTypeBulkUpload, ProjectClientAdd, ProjectClientUpdate, ProjectClientDelete, ProjectClientBulkUpload, ProjectBulkUpload };